{
    let isBigEng = /^[A-Z]+$/; //大寫
    let isEngNum = /^[a-zA-Z0-9]+$/; //輸入英文數字
    let isNum = /^[0-9]+$/;  //只輸入數字
    let isChinese = /^[\u4e00-\u9fd5\u3400-\u4db5]+$/  //只輸入中文
    let isNumAndBigEng = /^[0-9A-Z]+$/
    let isPid = /^[A-Z]{1}[1289]{1}[0-9]{8}$/
    let isLine = /(^[\.\_\-a-z0-9]+$)/ // Line ID判斷
    let isMobile = /^09\d{8}$/; // 手機號碼驗證
    let accRegular = {"regular": new RegExp($('#accRegular').val()) , "regularMsg": $('#accRegularMsg').val()};
    var isUsdt = /^/;
    var bankCode = 0;
    $(function() {
        $("#usdtType select[name='bankname_usdt']").change(function() {
            bankCode = $(this).find(":selected").data('bankcode');
            if (bankCode == 'ERC20') {
                isUsdt = /^0x[0-9A-Za-z]*$/;
            } else if (bankCode == 'TRC20') {
                isUsdt = /^T[0-9A-Za-z]*$/;
            }else {
                isUsdt = /^/;
            }
        })
    });

    var joinValidate = $('#joinValidate').val() ? true : false

    var VueComponent = new Vue({
        el: '#app',
        components: {
            'marquee-box': httpVueLoader(`/tpl/${theme}/components/marquee.vue`),
            'gametab-box': httpVueLoader(`/tpl/${theme}/components/gameTab.vue?${version}`),
            'gamenav-box': httpVueLoader(`/tpl/${theme}/components/gameNav.vue?${version}`),
            'app-box': httpVueLoader(`/tpl/${theme}/components/app.vue?${version}`),
            'rank-box': httpVueLoader(`/tpl/${theme}/components/rank.vue?${version}`),
            'about-box': httpVueLoader(`/tpl/${theme}/components/about.vue?${version}`),
            'vendor-box': httpVueLoader(`/tpl/${theme}/components/vendor.vue?1108`),  //廠商圖
            'footer-box': httpVueLoader(`/tpl/${theme}/components/footer.vue`),  //footer
            //game
            'live-box': httpVueLoader(`/tpl/${theme}/components/game/live.vue?${version}`),
            'sport-box': httpVueLoader(`/tpl/${theme}/components/game/sport.vue?${version}`),
            'slot-box': httpVueLoader(`/tpl/${theme}/components/game/slot.vue?${version}`),
            'lottery-box': httpVueLoader(`/tpl/${theme}/components/game/lottery.vue?${version}`),
            'poker-box': httpVueLoader(`/tpl/${theme}/components/game/poker.vue?${version}`),
            'fish-box': httpVueLoader(`/tpl/${theme}/components/game/fish.vue?${version}`),
            
            //game自薦大廳
            'live-hall': httpVueLoader(`/tpl/${theme}/components/game/livehall.vue?${version}`),
            'sport-hall': httpVueLoader(`/tpl/${theme}/components/game/sporthall.vue?${version}`),
            'slot-hall': httpVueLoader(`/tpl/${theme}/components/game/slothall.vue?${version}`),
            'fish-hall': httpVueLoader(`/tpl/${theme}/components/game/fishhall.vue?${version}`),
            'poker-hall': httpVueLoader(`/tpl/${theme}/components/game/pokerhall.vue?${version}`),

            //member
            'member-aside': httpVueLoader(`/tpl/${theme}/components/member/aside.vue`),  //member選單
            'transfer-detail': httpVueLoader(`/tpl/${theme}/components/member/transfer.vue`),  //轉點遊戲列表
            'contactus': httpVueLoader(`/tpl/${theme}/components/member/contactus.vue?${version}`),    //歷史訊息
            'record-store': httpVueLoader(`/tpl/${theme}/components/member/record_store.vue`),    //帳務紀錄
            //modal
            'line-box': httpVueLoader(`/tpl/${theme}/components/modal/lineModal.vue`),
            'service-box': httpVueLoader(`/tpl/${theme}/components/modal/serviceModal.vue`),
            'transfer-box': httpVueLoader(`/tpl/${theme}/components/modal/transferModal.vue?${version}`),
            //至頂按鈕
            'back-top': httpVueLoader(`/tpl/${theme}/components/backtop.vue`),
            'navbar': httpVueLoader(`/tpl/${theme}/components/navbar.vue?${version}`)
        },
        data() {
            return {
                // global setting
                regneedpbrth: $('#check18y').val() ? $('#check18y').val() : 'N',
                //login register
                accounth:"",         //登入帳號
                accounthNo:false,
                passwordh:"",        //登入密碼
                passwordhNo:false,
                account: "",         //帳號
                accountNo: false,
                password: "",        //新密碼
                passwordNo: false,
                chkpassword: "",     //再次密碼
                chkpasswordNo: false,
                captcha: "",        //驗證碼
                captchaNo: false,
                username: "",        //會員名稱
                usernameNo: false,
                regpbirth: "",       //生日
                regpbirthNo: false,
                phone: "",          //手機
                phoneNo: false,
                line: "",           //LINE
                lineNo: false,
                accountPID: "",     // 身分證
                accountPIDNo: false,
                Verificationcode: "",   //驗證碼
                VerificationcodeNo: false,
                oldupass: "",        //舊密碼
                oldupassNo: false,
                oldppass: "",        //舊提領密碼
                oldppassNo: false,
                newppass: "",        //新提領密碼
                newppassNo: false,
                chknewppass: "",     //新提領密碼
                chknewppassNo: false,
                newppass_usdt: "",        //USDT新提領密碼
                newppass_usdtNo: false,
                chknewppass_usdt: "",     //USDT新提領密碼
                chknewppass_usdtNo: false,
                sendtitle: "",       //站內標題
                sendtitleNo: false,
                sendcontent: "",     //站內內容
                sendcontentNo: false,
                account_name: $(`input[name='account_name']`).val() ?  $(`input[name='account_name']`).val() : $(`div[name='account_name']`).text(),      //銀行卡姓名
                account_nameNo:false,
                account_name_usdt: $(`input[name='account_name_usdt']`).val() ?  $(`input[name='account_name_usdt']`).val() : $(`div[name='account_name_usdt']`).text(),      //銀行卡姓名
                account_name_usdtNo:false,
                bankname: "0",  //銀行名稱
                banknameNo: false,
                bankname_usdt: "0",  //通道戶名
                bankname_usdtNo: false,
                branchname: "",      //分行名稱
                branchnameNo: false,
                branchcode: "",      //分行代碼
                branchcodeNo: false,
                bankaccount: "",     //銀行帳號
                bankaccountNo: false,
                bankaccount_usdt: "",     //通道地址
                bankaccount_usdtNo: false,
                account_name_ccd: $(`input[name='account_name_ccd']`).val() ?  $(`input[name='account_name_ccd']`).val() : $(`div[name='account_name_ccd']`).text(),
                account_name_ccdNo: false,
                bankname_ccd: 0,
                bankname_ccdNo: false,
                bankaccount_ccd: "",
                bankaccount_ccdNo: false,
                addCCD_DepositBookNo: false,
                addCCD_DepositBackBookNo: false,
                updateCCD_DepositBookNo : false,
                updateCCD_DepositBackBookNo : false,
                updateCCD_IDCardNo : false,
                updateCCD_IDCardBackImgNo : false,
                bankcounty: "",
                bankcountyNo: false,
                bankdistrict: "",
                bankdistrictNo: false,
                bankselect: "0",  //指定銀行卡
                bankselectNo: false,
                withdrawalselect:   $('#acc_id').val() ,  //提款類型
                miniWD: $('#acc_id').find(':selected').data('minin'),  //最小提款金額
                depositselect: "0",  //存款類型
                depositselectNo: false,
                branchcode2: "",        //店號
                branchcode2No: false,
                bankbranch: "",         //店名
                bankbranchNo: false,
                bonusselect: "0", //優惠類型
                amount: "",          //金額
                amountNo: false,
                amountUsdt: "",          //USDT金額
                amountUsdtNo: false,
                remark: "",          //銀行地址末五碼或通道地址
                remarkNo: false,
                transferfrom: '請選擇',  //轉出
                transferfromNo: false,
                transferto: '請選擇',    //轉入
                transfertoNo: false,
                max_transfer: "",       
                pamount: "",        //提領金額
                pamountNo: false,
                min_withdraw: false,  //最低提領金額
                max_withdraw: false,  //最高提領金額
                // other
                // getGame: $('#game').val(),
                logintype: true, //只顯示一次提示
                BonusID:'',
                userID: '',   //忘記密碼使用
                register_submit: false,
                updateBankImg: "",
                Bank_IDCardNo: false,
                Bank_IDCardBackImgNo: false,
                USDT_DepositBookNo: false,
                Bank_DepositBookNo: false
            }
        },
        watch: {
            accounth() {
                if($('#toLC').val() == 'Y'){
                    this.accounth = this.accounth.toLowerCase();
                }
                if (!isEngNum.test(this.accounth)) this.accounth = this.accounth.substring(0,this.accounth.length-1);
                if (this.accounth == '') this.checkError('accounth', '帳號不能為空')
                else if (!accRegular.regular.test(this.accounth)) this.checkError('accounth', accRegular.regularMsg);
                else this.checkTrue('accounth')
            },
            passwordh() {
                if (!isEngNum.test(this.passwordh)) this.passwordh = this.passwordh.substring(0,this.passwordh.length-1);
                if (this.passwordh == '') this.checkError('passwordh', '密碼不能為空')
                else if (this.passwordh.length < 6 || this.passwordh.length > 20) this.checkError('passwordh', '僅限6到20個英文及數字')
                else this.checkTrue('passwordh')
            },
            account() {
                if ($('#toLC').val() == 'Y') {
                    this.account = this.account.toLowerCase();
                }
                this.account = this.account.trim();
                if (!isEngNum.test(this.account)) this.account = this.account.substring(0, this.account.length - 1);
                if (this.account == '') this.checkError('account', '帳號不能為空')
                else if (!accRegular.regular.test(this.account)) this.checkError('account', accRegular.regularMsg);
                else this.checkTrue('account')
            },
            password() {
                if (!isEngNum.test(this.password)) this.password = this.password.substring(0, this.password.length - 1);
                if($("#pathName").val() == "member") {
                    if (this.password == '') this.checkError('password', '新密碼不能為空')
                    else if (this.password.length < 6 || this.password.length > 20) {
                        this.checkError('password', '僅限6到20個英文及數字')
                        if (this.password != this.chkpassword && this.chkpassword != '') this.checkError('chkpassword', '確認新密碼輸入不一致')
                        else this.checkTrue('chkpassword')
                    }
                    else if (this.oldupass == this.password) this.checkError('password', '新舊密碼不可相同')
                    else {
                        this.checkTrue('password')
                        if (this.password != this.chkpassword && this.chkpassword != '') this.checkError('chkpassword', '確認新密碼輸入不一致')
                        else this.checkTrue('chkpassword')
                    }
                }
                else {
                    if (this.password == '') this.checkError('password', '密碼不能為空')
                    else if (this.password.length < 6 || this.password.length > 20) {
                        this.checkError('password', '僅限6到20個英文及數字')
                        if (this.password != this.chkpassword && this.chkpassword != '') this.checkError('chkpassword', '確認密碼輸入不一致')
                        else this.checkTrue('chkpassword')
                    }
                    else {
                        this.checkTrue('password')
                        if (this.password != this.chkpassword && this.chkpassword != '') this.checkError('chkpassword', '確認密碼輸入不一致')
                        else this.checkTrue('chkpassword')
                    }
                }
            },
            chkpassword() {
                if (!isEngNum.test(this.chkpassword)) this.chkpassword = this.chkpassword.substring(0, this.chkpassword.length - 1);
                if($("#pathName").val() == "member") {
                    if (this.chkpassword == '') this.checkError('chkpassword', '確認新密碼不能為空')
                    else if (this.password != this.chkpassword) this.checkError('chkpassword', '確認新密碼輸入不一致')
                    else this.checkTrue('chkpassword')
                } 
                else {
                    if (this.chkpassword == '') this.checkError('chkpassword', '確認密碼不能為空')
                    else if (this.password != this.chkpassword) this.checkError('chkpassword', '確認密碼輸入不一致')
                    else this.checkTrue('chkpassword')
                }
            },
            captcha() {
                if (!isNum.test(this.captcha)) this.captcha = this.captcha.substring(0, this.captcha.length - 1);
                if (this.captcha == '') this.checkError('captcha', '驗證碼不能為空')
                else this.checkTrue('captcha')
            },
            username() {
                if (!isChinese.test(this.username)) this.username = this.username.substring(0, this.username.length - 1);
                if (this.username == '') this.checkError('username', '真實姓名不能為空')
                else this.checkTrue('username')
            },
            regpbirth() {
                if (this.regpbirth == '') this.checkError('regpbirth', '生日不能為空')
                else this.checkTrue('regpbirth')
            },
            accountPID() {
                if (!isEngNum.test(this.accountPID)) this.accountPID = this.accountPID.substring(0, this.accountPID.length - 1);
                if (this.accountPID == '') this.checkError('accountPID', '請輸入銀行帳戶身分證字號')
                // else if ($('#accpid').val() == 'Y' && !isPid.test(this.accountPID)) this.checkError('accountPID', '身分證字號格式有誤')
                else {
                    this.accountPID = this.accountPID.toUpperCase();
                    this.checkTrue('accountPID')
                }
            },
            line() {
                if (!isLine.test(this.line)) this.line = this.line.substring(0, this.line.length - 1);
                if ($('#line').val() == 'Y' && $('#line_required').val() == "Y") {
                    if (this.line == '') this.checkError('line', 'LINE ID 不能為空')
                    else this.checkTrue('line')
                }
            },
            phone() {
                if (!isNum.test(this.phone)) this.phone = this.phone.substring(0, this.phone.length - 1);
                if (this.phone == '') this.checkError('phone', '手機不能為空')
                else if (this.phone.length < 10) this.checkError('phone', '手機僅限10碼')
                else if (!isMobile.test(this.phone)) this.checkError('phone', '請輸入有效的手機號碼')
                else this.checkTrue('phone')

                if (isMobile.test(this.phone)) this.regCheck('phone', this.phone)
                else $(".sendActbtn").prop("disabled", true).addClass("disabled");
            },
            Verificationcode() {
                if (!isNum.test(this.Verificationcode)) this.Verificationcode = this.Verificationcode.substring(0, this.Verificationcode.length - 1);
                if (this.Verificationcode == '') this.checkError('Verificationcode', '驗證碼不能為空')
                else this.checkTrue('Verificationcode')
            },
            oldupass() {
                if (!isEngNum.test(this.oldupass)) this.oldupass = this.oldupass.substring(0, this.oldupass.length - 1);
                if (this.oldupass == '') this.checkError('oldupass', '當前密碼不能為空')
                else if (this.oldupass.length < 6 || this.oldupass.length > 20) this.checkError('oldupass', '僅限6到20個英文及數字')
                else this.checkTrue('oldupass')
            },
            oldppass() {
                if (!isEngNum.test(this.oldppass)) this.oldppass = this.oldppass.substring(0, this.oldppass.length - 1);
                if (this.oldppass == '') {
                    this.checkError('oldppass', '當前密碼不能為空')
                    $(`input[name=bankPass]`).addClass('error-focus');
                }
                else if (this.oldppass.length < 4 || this.oldppass.length > 10) {
                    this.checkError('oldppass', '僅限4到10個英文及數字')
                    $(`input[name=bankPass]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('oldppass')
                    $(`input[name=bankPass]`).removeClass('error-focus');
                }
            },
            newppass() {
                if (!isEngNum.test(this.newppass)) this.newppass = this.newppass.substring(0, this.newppass.length - 1);
                if (this.newppass == '') this.checkError('newppass', '提款密碼不能為空')
                else if (this.newppass.length < 4 || this.newppass.length > 10) {
                    this.checkError('newppass', '僅限4到10個英文及數字')
                    if (this.newppass != this.chknewppass && this.chknewppass != '') this.checkError('chknewppass', '確認提款密碼輸入不一致')
                    else this.checkTrue('chknewppass')
                } 
                else if (this.oldppass == this.newppass) this.checkError('newppass', '新舊密碼不可相同') 
                else {
                    this.checkTrue('newppass')
                    if (this.newppass != this.chknewppass && this.chknewppass != '') this.checkError('chknewppass', '確認提款密碼輸入不一致')
                    else this.checkTrue('chknewppass')
                }
            },
            chknewppass() {
                if (!isEngNum.test(this.chknewppass)) this.chknewppass = this.chknewppass.substring(0, this.chknewppass.length - 1);
                if (this.chknewppass == '') this.checkError('chknewppass', '確認提款密碼不能為空')
                else if (this.newppass != this.chknewppass) this.checkError('chknewppass', '確認提款密碼輸入不一致')
                else this.checkTrue('chknewppass')
            },
            sendtitle() {
                if (this.sendtitle == '') this.checkError('sendtitle', '標題不能為空')
                else this.checkTrue('sendtitle')
            },
            sendcontent() {
                if (this.sendcontent == '' && $('textarea').is(':focus')) {
                    this.checkError('sendcontent', '訊息內容不能為空')
                    $('.textarea-block').addClass('error-focus')
                } else {
                    this.checkTrue('sendcontent')
                    $('.textarea-block').removeClass('error-focus')
                }
            },
            account_name() {
                let sw_ubank_accname = $("#sw_ubank_accname").val();
                if (!isChinese.test(this.account_name) && sw_ubank_accname == "Y") this.account_name = this.account_name.substring(0,this.account_name.length-1);
                if (this.account_name == '') this.checkError('account_name', '銀行戶名不能為空')
                else this.checkTrue('account_name')
            },
            account_name_usdt() {
                let sw_ubank_accname = $("#sw_ubank_accname").val();
                if (!isChinese.test(this.account_name_usdt) && sw_ubank_accname == "Y") this.account_name_usdt = this.account_name_usdt.substring(0,this.account_name_usdt.length-1);
                if (this.account_name_usdt == '') this.checkError('account_name_usdt', '通道戶名不能為空')
                else this.checkTrue('account_name_usdt')
            },
            bankname() {
                if (this.bankname == '0') this.checkError('bankname', '請選擇銀行名稱')
                else this.checkTrue('bankname')
            },    
            bankname_usdt() {
                if (this.bankname_usdt == '0') this.checkError('bankname_usdt', '請選擇通道類型')
                else this.checkTrue('bankname_usdt')
            },    
            bankaccount() {
                if (!isNum.test(this.bankaccount)) this.bankaccount = this.bankaccount.substring(0, this.bankaccount.length - 1);
                if (this.bankaccount == '') this.checkError('bankaccount', '銀行帳號不能為空')
                else if (this.bankaccount.length < 10 || this.bankaccount.length > 19) this.checkError('bankaccount', '僅限10到19個數字')
                else this.checkTrue('bankaccount')
            },
            bankaccount_usdt() {
                // if (!isUsdt.test(this.bankaccount_usdt)) this.bankaccount_usdt = this.bankaccount_usdt.substring(0, this.bankaccount_usdt.length - 1);
                if (this.bankaccount_usdt == '') this.checkError('bankaccount_usdt', '通道地址不能為空')
                else if (bankCode == "TRC20" && (this.bankaccount_usdt.length != 34 || !isUsdt.test(this.bankaccount_usdt))) this.checkError('bankaccount_usdt', '僅限開頭為T的34個英文或數字。')
                else if (bankCode == "ERC20" && (this.bankaccount_usdt.length != 42 || !isUsdt.test(this.bankaccount_usdt))) this.checkError('bankaccount_usdt', '僅限開頭為0x的42個英文或數字。')
                else this.checkTrue('bankaccount_usdt')
            },
            branchname() {
                if (!isChinese.test(this.branchname)) this.branchname = this.branchname.substring(0, this.branchname.length - 1);
                if (this.branchname == '') this.checkError('branchname', '分行名稱不能為空')
                else this.checkTrue('branchname')
            },
            branchcode() {
                if (!isNum.test(this.branchcode)) this.branchcode = this.branchcode.substring(0, this.branchcode.length - 1);
                if (this.branchcode == '') this.checkError('branchcode', '分行代碼不能為空')
                else if (this.branchcode.length != 4) this.checkError('branchcode', '僅限4個數字')
                else this.checkTrue('branchcode')
            },
            branchcode2() {
                if (!isNumAndBigEng.test(this.branchcode2)) this.branchcode2 = this.branchcode2.substring(0, this.branchcode2.length - 1);
                if (this.branchcode2 == '') this.checkError('branchcode2', '店號不能為空')
                else if (this.branchcode2.length > 10) this.checkError('branchcode2', '限10個數字內')
                else this.checkTrue('branchcode2')
            },
            bankbranch() {
                if (!isChinese.test(this.bankbranch)) {
                    this.bankbranch = this.bankbranch.substring(0, this.bankbranch.length - 1);
                }
                if (this.bankbranch == '') {
                    this.checkError('bankbranch', '店名不能為空');
                } else {
                    this.checkTrue('bankbranch');
                }
            },
            bankcounty() {
                if (!isChinese.test(this.bankcounty)) {
                    this.bankcounty = this.bankcounty.substring(0, this.bankcounty.length - 1);
                }
                if (this.bankcounty == '') {
                    this.checkError('bankcounty', '縣市不能為空');
                } else {
                    this.checkTrue('bankcounty');
                }
            },
            bankdistrict() {
                if (!isChinese.test(this.bankdistrict)) {
                    this.bankdistrict = this.bankdistrict.substring(0, this.bankdistrict.length - 1);
                }
                if (this.bankdistrict == '') {
                    this.checkError('bankdistrict', '鄉鎮市區不能為空');
                } else {
                    this.checkTrue('bankdistrict');
                }
            },
            withdrawalselect() {
                this.miniWD = $('#acc_id').find(':selected').data('minin')
                if (this.pamount != '') {
                    this.checkError('pamount', `最低提領金額:${parseInt(this.miniWD)}`)
                }
            },
            depositselect() {
                if (this.depositselect == "0") {
                    this.checkError('depositselect', '請選擇存款類型')
                    $(`select[name=AccID]`).addClass('error-focus');
                    if (this.amount != '' && this.bonusselect != "0") {
                        if (this.amount < parseInt($('#p_min').text())) {
                            this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                            $(`input[name=Amount]`).addClass('error-focus');
                        }
                        else if (this.amount > parseInt($('#p_max').text())) {
                            this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                            $(`input[name=Amount]`).addClass('error-focus');
                        }
                    } 
                    else {
                        this.checkTrue('amount')
                        $(`input[name=Amount]`).removeClass('error-focus');
                    }
                }
                else {
                    this.checkTrue('depositselect')
                    $(`select[name=AccID]`).removeClass('error-focus');
                    if (this.amount < parseInt($('#p_min').text())) {
                        this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else if (this.amount > parseInt($('#p_max').text())) {
                        this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                }
            },
            bonusselect() {
                if (this.bonusselect == "0") {
                    if (this.amount != '' && this.depositselect != "0") {
                        if (this.amount < parseInt($('#p_min').text())) {
                            this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                            $(`input[name=Amount]`).addClass('error-focus');
                        }
                        else if (this.amount > parseInt($('#p_max').text())) {
                            this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                            $(`input[name=Amount]`).addClass('error-focus');
                        }
                    } 
                    else {
                        this.checkTrue('amount')
                        $(`input[name=Amount]`).removeClass('error-focus');
                    }
                } 
                else {
                    if (this.amount < parseInt($('#p_min').text())) {
                        this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else if (this.amount > parseInt($('#p_max').text())) {
                        this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                }
                
            },
            amount() {
                let bankBranch = $('#AccID').find(':selected').data('bankbranch');
                if (!isNum.test(this.amount) && typeof this.amount == "string") this.amount = this.amount.substring(0, this.amount.length - 1);
                if (this.amount == '' && this.amount != '0') {
                    this.checkError('amount', '請填入此欄位')
                    $(`input[name=Amount]`).addClass('error-focus');
                    $(`input[name=transferamount]`).addClass('error-focus');
                    this.min_amountNo = false
                    this.max_amountNo = false
                }
                else if ($(`#rulecondition`).val() !='' && new RegExp($(`#rulecondition`).val().replace(/^\/|\/$/g, '')).test(this.amount)) {
                    this.checkError('amount', $(`#rulemsg`).val())
                    $(`input[name=Amount]`).addClass('error-focus');
                }
                else if (this.amount < 1) {
                    this.checkError('amount', '金額不得小於1')
                    $(`input[name=Amount]`).addClass('error-focus');
                    $(`input[name=transferamount]`).addClass('error-focus');
                }
                else if (this.amount < parseInt($('#p_min').text())) {
                    this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                    $(`input[name=Amount]`).addClass('error-focus');
                }
                else if (this.amount > parseInt($('#p_max').text())) {
                    this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                    $(`input[name=Amount]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('amount')
                    $(`input[name=Amount]`).removeClass('error-focus');
                    $(`input[name=transferamount]`).removeClass('error-focus');
                    if(this.amount > parseInt($('#max_transfer').val()) && this.transferfrom != "請選擇") {
                        this.checkError('amount', `最大額度: ${parseInt($('#max_transfer').val())}`)
                        $(`input[name=transferamount]`).addClass('error-focus');
                    } else {
                        this.checkTrue('amount')
                        $(`input[name=transferamount]`).removeClass('error-focus');
                    }
                }
            },
            amountUsdt() {
                if (!isNum.test(this.amountUsdt)) this.amountUsdt = this.amountUsdt.substring(0, this.amountUsdt.length - 1);
                this.amount = Math.round(this.amountUsdt * exchange * 100) / 100;
                if (this.amount == '' && this.amount != '0') {
                    this.checkError('amount', '請填入此欄位')
                    $(`input[name=Amount]`).addClass('error-focus');
                    $(`input[name=transferamount]`).addClass('error-focus');
                    this.min_amountNo = false
                    this.max_amountNo = false
                }
                else if (this.amount < 1) {
                    this.checkError('amount', '金額不得小於1')
                    $(`input[name=Amount]`).addClass('error-focus');
                    $(`input[name=transferamount]`).addClass('error-focus');
                }
                else if (this.amount < parseInt($('#p_min').text())) {
                    this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                    $(`input[name=Amount]`).addClass('error-focus');
                }
                else if (this.amount > parseInt($('#p_max').text())) {
                    this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                    $(`input[name=Amount]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('amount')
                    $(`input[name=Amount]`).removeClass('error-focus');
                    $(`input[name=transferamount]`).removeClass('error-focus');
                    if(this.amount > parseInt($('#max_transfer').val()) && this.transferfrom != "請選擇") {
                        this.checkError('amount', `最大額度: ${parseInt($('#max_transfer').val())}`)
                        $(`input[name=transferamount]`).addClass('error-focus');
                    } else {
                        this.checkTrue('amount')
                        $(`input[name=transferamount]`).removeClass('error-focus');
                    }
                }
                this.pamount = Math.round(this.amountUsdt * exchange * 100) / 100;
                if (this.pamount == '' && this.pamount != '0') {
                    this.checkError('pamount', '請填入提領金額')
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else if (parseInt(this.pamount) > parseInt($('#uUserBalance').val())) {
                    this.checkError('pamount', `最高提領金額:${parseInt($('#uUserBalance').val())}`)
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else if (parseInt(this.pamount) < parseInt(this.miniWD)) {
                    this.checkError('pamount', `最低提領金額:${parseInt(this.miniWD)}`)
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('pamount')
                    $(`input[name=amount]`).removeClass('error-focus');
                }
            },
            remark() {
                if (this.remark == '' && acctype == 'deposit') {
                    this.checkError('remark', '請填入此欄位')
                    $(`input[name=Remark]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('remark')
                    $(`input[name=Remark]`).removeClass('error-focus');
                }
            },
            transferfrom() {
                if (this.transferfrom == "請選擇") this.checkError('transferfrom', '請填入此欄位')
                else this.checkTrue('transferfrom')
                $(`#transferto > div > option`).unwrap();
                $(`#transferto > option`).show()
                $(`#transferto > option[value="${this.transferfrom}"]`).hide()
                $(`#transferto > option[value="${this.transferfrom}"]`).wrap("<div></div>");
                $('#max_transfer').val($(`#${this.transferfrom}`).text())
                if(this.amount > parseInt($('#max_transfer').val()) && this.transferfrom != "請選擇") {
                    this.checkError('amount', `最大額度: ${parseInt($('#max_transfer').val())}`)
                    $(`input[name=transferamount]`).addClass('error-focus');
                } else {
                    this.checkTrue('amount')
                    $(`input[name=transferamount]`).removeClass('error-focus');
                }
            },
            transferto() {
                if (this.transferto == '請選擇') this.checkError('transferto', '請填入此欄位')
                else this.checkTrue('transferto')
                $(`#transferfrom > div > option`).unwrap();
                $(`#transferfrom > option`).show()
                $(`#transferfrom > option[value="${this.transferto}"]`).hide()
                $(`#transferfrom > option[value="${this.transferto}"]`).wrap("<div></div>");
            },
            pamount() {
                if (!isNum.test(this.pamount)  && typeof this.pamount == "string") this.pamount = this.pamount.substring(0, this.pamount.length - 1);
                if (this.pamount == '' && this.pamount != '0') {
                    this.checkError('pamount', '請填入提領金額')
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else if (parseInt(this.pamount) > parseInt($('#uUserBalance').val())) {
                    this.checkError('pamount', `最高提領金額:${parseInt($('#uUserBalance').val())}`)
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else if (parseInt(this.pamount) < parseInt(this.miniWD)) {
                    this.checkError('pamount', `最低提領金額:${parseInt(this.miniWD)}`)
                    $(`input[name=amount]`).addClass('error-focus');
                }
                else {
                    this.checkTrue('pamount')
                    $(`input[name=amount]`).removeClass('error-focus');
                }
            },
        },
        mounted() {
            this.registerCheck();
            isLogin && this.getibacc();
        },
        methods: {
            hallLabel(hallstatus, game) {
                const hall = hallstatus.find(h => h.HallCode === game.Hallid || h.HallCode === game.Eid || h.HallCode === game.Hall);
                return hall ? hall.StateLabel : '維護中';
            },
            modalPosition(name) {
                if(name != 'Register') {
                    let el = `#${name} .modal > div`
                    let winHigh = $(window).height();
                    let modalHigh = $(el).height() + 40;
                    if (modalHigh < winHigh) {
                        $(el).removeClass("top");
                        $(el).addClass("center");
                    } else {
                        $(el).addClass("top");
                        $(el).removeClass("center");
                    }
                }
            },
            showModal(name) {
                if (name == 'Register' && joinValidate) {
                    $(`.modal>div`).removeClass("active");
                    setTimeout(function() {
                        $("body").removeClass("hide");
                        $(".modalBox").hide();
                    }, 300)
                    return
                }
                if (name == 'OnLine') {
                    this.resetForm('login')
                }
                $(".modalBox").hide();
                $("body").addClass('hide')
                setTimeout(function() {
                    $(`#${name} .modal>div`).addClass("active");
                }, 5)
                $(`#${name}`).show()
                this.modalPosition(name)
            },
            hideModal(name) {
                if (joinValidate) return location.href = './';
                this.resetForm(name)
                $(`.modal>div`).removeClass("active");
                setTimeout(function() {
                    $("body").removeClass("hide");
                    $(".modalBox").hide();
                }, 300)
            },
            outModal(event, name) {
                if (joinValidate) return;
                if (!$(event.target).closest(".modal > div").length) {
                    this.resetForm(name)
                    $(`.modal>div`).removeClass("active");
                    setTimeout(function() {
                        $("body").removeClass("hide");
                        $(".modalBox").hide();
                    }, 300)
                }
            },
            //優惠modal
            openProModal(event, BonusID) {
                $('.bonus-btn').hide().attr('disabled', 'disabled');
                $('.bonus-remark').hide().text("")
                let el = event.currentTarget;
                let modal = $(el).next().find('.pro-modal')
                $('.bonus-btn').hide().attr('disabled', 'disabled');
                this.BonusID = BonusID;
                if (isLogin) this.showBonusButton();
                if(annType) {
                    $("html,body").scrollTop(0);
                    $("body").addClass("hide");
                    $(el).next().show()
                } else {
                    $("body").addClass("hide");
                    $(el).next().show()
                    let winHigh = $(window).height();
                    let modalHigh = modal.height() + 40;
                    if (modalHigh < winHigh) {
                        modal.removeClass("top");
                        modal.addClass("center");
                    } else {
                        modal.addClass("top");
                        modal.removeClass("center");
                    }
                    setTimeout(function() {
                        modal.addClass("active")
                    }, 5)
                }
            },
            outProModal(event) {
                if (!$(event.target).closest(".pro-modal").length) {
                    $(".pro-modal").removeClass("active")
                    setTimeout(function() {
                        $("body").removeClass("hide");
                        $(".pro-deskBox").hide();  
                    }, 300)
                }
            },
            hideProModal() {
                $(".pro-modal").removeClass("active")
                setTimeout(function() {
                    $("body").removeClass("hide");
                    $(".pro-deskBox").hide();
                    $(".pro-mobBox").hide();
                }, 300)
            },
            //平台公告
            openBulletin(event) {
                $(".bulletin_table .top").hide()
                $(".tableTop .icons, .header-title .icons").show()
                $(".table-item .table-title").hide()
                let el = event.currentTarget;
                $(el).find(".table-title").show().addClass('active')
                $(el).find(".table-content").show()
            },
            hideBulletin() {
                $(".bulletin_table .top").show()
                $(".tableTop .icons, .header-title .icons").hide()
                $(".table-item .table-title").show().removeClass('active')
                $(".table-item .table-content").hide()
            },
            hideContactus() {
                $(".contactus_table .top").show()
                $(".tableTop .icons").hide()
                $(".table-item .table-title").show().removeClass('active')
                $(".table-item .table-content").hide()
            },
            //規則與條例
            showRegulations() {
                $(".modalBox").hide();
                $("body").addClass('hide')
                $("#Regulations").show()
                setTimeout(function() {
                    $(`#Regulations .modal>div`).addClass("active");
                }, 5)
                this.modalPosition('Regulations')
            },
            //首頁錢包點選後刷新金額
            getMasterBalance() {
                $(".Master_Balance").text('查詢中...');
                $(".Master_Balance").next().addClass('circle-360');
                axios.post('../../member_act.php', Qs.stringify({
                    a: 'getBalance',
                    h: 'Master'
                }))
                .then(res => {
                    if (res.data.success == 0) {
                        $(".Master_Balance").text(res.data.data.Balance);
                        $(".Master_Balance").next().removeClass('circle-360');
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                    }
                })
                .catch(err => {
                    $(".Master_Balance").text('連線失敗');
                })
            },
            //發送手機驗證
            getPhoneVcode(type) {
                if (type == 'forget' && this.account.length == 0) return alertError('請輸入帳號', 'account')
                if (!isMobile.test(this.phone)) return alertError('請輸入可接收簡訊的行動電話號碼', 'phone')
                $(".sendActbtn").prop("disabled", true).addClass("disabled");
                let data = {
                    a: 'sendActivation',
                    mobile: this.phone
                }
                if (type == 'forget') {
                    data.forwhat = 2
                    data.useraccount = this.account
                }
                axios.post('/registration_act.php', Qs.stringify(data))
                .then(res => {
                    if (res.data.success == 0) {
                        this.setTimeDown(60);
                        alertSuccess(res.data.msg)
                    } else {
                        $(".sendActbtn").prop('disabled', false).removeClass("disabled");
                        alertError(res.data.msg)
                    }
                })
                .catch(err => {
                    $(".sendActbtn").prop('disabled', false).removeClass("disabled");
                })
            },
            //驗證重發倒數
            setTimeDown(remainTime) {
                let count = setInterval(function () {
                    $(".sendActbtn").text(`重新獲得(${remainTime < 10 ? ('0'+remainTime) : remainTime }s)`)
                    //當剩餘時間 > 0，將剩餘時間減去一秒，並重新顯示在頁面上
                    if (remainTime > 0) {
                        remainTime--;
                    //當剩餘時間 =< 0，清除 setInterval() 函式
                    } else {
                        clearInterval(count);
                        $(".sendActbtn").prop('disabled', false).removeClass("disabled").text("獲得驗證碼");
                    }
                }, 1000) 
            },

            //表單驗證
            checkForm(i) {
                //登入
                if(i == 'login') {
                    //帳號
                    if (this.accounth == '') this.checkError('accounth', '帳號不能為空')
                    else if (this.accounth.length < 6 || this.accounth.length > 20) this.checkError('accounth', '僅限6到20個英文及數字')
                    else this.checkTrue('accounth')
                    //密碼
                    if (this.passwordh == '') this.checkError('passwordh', '密碼不能為空')
                    else if (this.passwordh.length < 6 || this.passwordh.length > 20) this.checkError('passwordh', '僅限6到20個英文及數字')
                    else this.checkTrue('passwordh')
                    //驗證碼
                    if (this.captcha == '') this.checkError('captcha', '驗證碼不能為空')
                    else this.checkTrue('captcha')
            
                    if (this.accounth == '') alertError('帳號不能為空', 'accounth')
                    else if (this.accounth.length < 6 || this.accounth.length > 20)  alertError('帳號僅限6到20個英文及數字', 'accounth')
                    else if (this.passwordh == '') alertError('密碼不能為空', 'passwordh')
                    else if (this.passwordh.length < 6 || this.passwordh.length > 20)  alertError('密碼僅限6到20個英文及數字', 'passwordh')
                    else if (this.captcha == '') alertError('驗證碼不能為空', 'captcha')
                    else {
                        this.login()
                    }
                }
                //註冊
                if (i == 'register') {
                    //帳號
                    if (this.account == '') this.checkError('account', '帳號不能為空')
                    else if (!accRegular.regular.test(this.account)) this.checkError('account', accRegular.regularMsg);
                    else this.checkTrue('account')
                    //密碼
                    if (this.password == '') this.checkError('password', '密碼不能為空')
                    else if (this.password.length < 6 || this.password.length > 20) this.checkError('password', '僅限6到20個英文及數字')
                    else this.checkTrue('password')
                    //確認密碼
                    if (this.chkpassword == '') this.checkError('chkpassword', '確認密碼不能為空')
                    else if (this.password != this.chkpassword) this.checkError('chkpassword', '確認密碼輸入不一致')
                    else this.checkTrue('chkpassword')
                    //用戶名
                    if (this.username == '') this.checkError('username', '真實姓名不能為空')
                    else this.checkTrue('username')
                    //生日
                    if ($('#regpbirth').val() == 'Y' && this.regpbirth == '') this.checkError('regpbirth', '生日不能為空')
                    else this.checkTrue('regpbirth')
                    //line
                    if ($('#line').val() == 'Y' && $('#line_required').val() == "Y" && this.line == '') this.checkError('line', 'LINE ID 不能為空')
                    else if ($('#line').val() == 'Y' && $('#line_required').val() == "Y" && !isLine.test(this.line)) this.checkError('line', 'LINE ID 格式有誤')
                    else this.checkTrue('line')
                    //手機
                    if (this.phone == '') this.checkError('phone', '手機不能為空')
                    else if (this.phone.length < 10) this.checkError('phone', '手機僅限10碼')
                    else if (!isMobile.test(this.phone)) this.checkError('phone', '請輸入有效的手機號碼')
                    else this.checkTrue('phone')
                    //驗證碼
                    if ($('#regactivation').val() == 'Y' && this.Verificationcode == '') this.checkError('Verificationcode', '驗證碼不能為空')
                    else this.checkTrue('Verificationcode')
                    
                    if (this.account == '') alertError('帳號不能為空', 'account')
                    else if (!accRegular.regular.test(this.account)) this.checkError(accRegular.regularMsg, 'account');
                    else if (this.password == '') alertError('密碼不能為空', 'password')
                    else if (this.password.length < 6 || this.password.length > 20) alertError('密碼僅限6到20個英文及數字', 'password')
                    else if (this.chkpassword == '') alertError('確認密碼不能為空', 'chkpassword')
                    else if (this.password != this.chkpassword) alertError('確認密碼輸入不一致', 'chkpassword')
                    else if (this.username == '') alertError('真實姓名不能為空', 'username')
                    else if ($('#regpbirth').val() == 'Y' && this.regpbirth == '') alertError('生日不能為空', 'regpbirth')
                    else if ($('#line').val() == 'Y' && $('#line_required').val() == "Y" && this.line == '') alertError('LINE ID 不能為空', 'line')
                    else if ($('#line').val() == 'Y' && $('#line_required').val() == "Y" && !isLine.test(this.line)) alertError('LINE ID 格式有誤', 'line')
                    else if (this.phone == '') alertError('手機不能為空', 'phone')
                    else if (this.phone.length < 10) alertError('手機僅限10碼', 'phone')
                    else if (!isMobile.test(this.phone)) alertError('請輸入有效的手機號碼', 'phone')
                    else if ($('#regactivation').val() == 'Y' && this.Verificationcode == '') alertError('驗證碼不能為空', 'Verificationcode')
                    else if ($('#regulations').prop("checked") == false) alertError('會員註冊條例未選取', 'regulations')
                    else {
                        if (!this.register_submit) {
                            this.register_submit = true;
                            this.register()
                        }
                    }
                }
                //個人設定
                if (i == 'member') {
                    //當前密碼
                    if (this.oldupass == '') this.checkError('oldupass', '當前密碼不能為空')
                    else if (this.oldupass.length < 6 || this.oldupass.length > 20) this.checkError('oldupass', '僅限6到20個英文及數字')
                    else this.checkTrue('oldupass')
                    //密碼
                    if (this.password == '') this.checkError('password', '密碼不能為空')
                    else if (this.password.length < 6 || this.password.length > 20) this.checkError('password', '僅限6到20個英文及數字')
                    else if (this.oldupass == this.password) this.checkError('password', '新舊密碼不可相同')
                    else this.checkTrue('password')
                    //確認密碼
                    if (this.chkpassword == '') this.checkError('chkpassword', '確認新密碼不能為空')
                    else if (this.password != this.chkpassword) this.checkError('chkpassword', '確認新密碼輸入不一致')
                    else this.checkTrue('chkpassword')

                    if (this.oldupass == '') alertError('當前密碼不能為空', 'oldupass')
                    else if (this.oldupass.length < 6 || this.oldupass.length > 20) alertError('當前密碼僅限6到20個英文及數字', 'oldupass')
                    else if (this.password == '') alertError('密碼不能為空', 'password')
                    else if (this.password.length < 6 || this.password.length > 20) alertError('新密碼僅限6到20個英文及數字', 'password')
                    else if (this.oldupass == this.password) alertError('新舊密碼不可相同', 'password')
                    else if (this.chkpassword == '') alertError('確認新密碼不能為空', 'chkpassword')
                    else if (this.password != this.chkpassword) alertError('確認新密碼輸入不一致', 'chkpassword')
                    else {
                        this.resetupass()
                    }
                }
                //銀行卡管理
                if (i == 'jsbank_list') {
                    var hasBankPass = $("#hasBankPass").val() === "1";
                    //當前提款密碼（僅有密碼時驗證）
                    if (hasBankPass) {
                        if (this.oldppass == '') this.checkError('oldppass', '當前密碼不能為空')
                        else if (this.oldppass.length < 4 || this.oldppass.length > 10) this.checkError('oldppass', '僅限4到10個英文及數字')
                        else this.checkTrue('oldppass')
                    }
                    //提款密碼
                    if (this.newppass == '') this.checkError('newppass', '提款密碼不能為空')
                    else if (this.newppass.length < 4 || this.newppass.length > 10) this.checkError('newppass', '僅限4到10個英文及數字')
                    else if (hasBankPass && this.oldppass == this.newppass) this.checkError('newppass', '新舊密碼不可相同')
                    else this.checkTrue('newppass')
                    //確認密碼
                    if (this.chknewppass == '') this.checkError('chknewppass', '確認提款密碼不能為空')
                    else if (this.newppass != this.chknewppass) this.checkError('chknewppass', '確認提款密碼輸入不一致')
                    else this.checkTrue('chknewppass')

                    if (hasBankPass && this.oldppass == '') alertError('當前密碼不能為空', 'oldppass')
                    else if (hasBankPass && (this.oldppass.length < 4 || this.oldppass.length > 10)) alertError('當前密碼僅限4到10個英文及數字', 'oldppass')
                    else if (this.newppass == '') alertError('提款密碼不能為空', 'newppass')
                    else if (this.newppass.length < 4 || this.newppass.length > 10) alertError('提款密碼僅限4到10個英文及數字', 'newppass')
                    else if (hasBankPass && this.oldppass == this.newppass) alertError('新舊密碼不可相同', 'newppass')
                    else if (this.chknewppass == '') alertError('確認提款密碼不能為空', 'chknewppass')
                    else if (this.newppass != this.chknewppass) alertError('確認提款密碼輸入不一致', 'chknewppass')
                    else {
                        this.resetppass();
                    }
                }
                if (i == 'jsbank_add') {
                    this.bankform = 'addBank';
                    //銀行戶名
                    if (this.account_name == '') this.checkError('account_name', '銀行戶名不能為空')
                    else if (!isChinese.test(this.account_name)) this.checkError('account_name', '銀行戶名僅限中文')
                    else this.checkTrue('account_name')
                    //銀行名稱
                    if (this.bankname == '0') this.checkError('bankname', '請選擇銀行名稱')
                    else this.checkTrue('bankname')
                    //銀行帳號
                    if (this.bankaccount == '') this.checkError('bankaccount', '銀行帳號不能為空')
                    else if (this.bankaccount.length < 10 || this.bankaccount.length > 19) this.checkError('bankaccount', '僅限10到19個數字')
                    else this.checkTrue('bankaccount')
                    //分行名稱
                    if (this.branchname == '') this.checkError('branchname', '分行名稱不能為空')
                    else this.checkTrue('branchname')
                    //分行代碼
                    if (this.branchcode == '') this.checkError('branchcode', '分行代碼不能為空')
                    else if (!isNum.test(this.branchcode)) this.checkError('branchcode', '分行代碼僅限數字')
                    else if (this.branchcode.length != 4) this.checkError('branchcode', '僅限4個數字')
                    else this.checkTrue('branchcode')
                    //身分證字號
                    if ($('#accpid').val() == 'Y' && this.accountPID == '') this.checkError('accountPID', '請輸入銀行帳戶身分證字號')
                    // else if ($('#accpid').val() == 'Y' && !isPid.test(this.accountPID)) this.checkError('accountPID', '身分證字號格式有誤')
                    else this.checkTrue('accountPID')
                    //生日
                    if ($('#accpbirth').val() == 'Y' && this.regpbirth == '') this.checkError('regpbirth', '請輸入銀行帳戶出生年月日')
                    else this.checkTrue('regpbirth')  

                    if ($('#uBankCF').val() == 0 && $('#usUsdt').val() == 0) {
                        //提款密碼
                        if (this.newppass == '') this.checkError('newppass', '提款密碼不能為空')
                        else if (this.newppass.length < 4 || this.newppass.length > 10) this.checkError('newppass', '僅限4到10個英文及數字')
                        else this.checkTrue('newppass')
                        //確認密碼
                        if (this.chknewppass == '') this.checkError('chknewppass', '確認提款密碼不能為空')
                        else if (this.newppass != this.chknewppass) this.checkError('chknewppass', '確認提款密碼輸入不一致')
                        else this.checkTrue('chknewppass')

                        if (this.account_name == '') alertError('銀行戶名不能為空', 'account_name')
                        else if (this.bankname == '0') alertError('請選擇銀行名稱', 'bankname')
                        else if (this.bankaccount == '') alertError('銀行帳號不能為空', 'bankaccount')
                        else if (this.bankaccount.length < 10 || this.bankaccount.length > 19) alertError('銀行帳號僅限10到19個數字', 'bankaccount')
                        else if (this.branchname == '') alertError('分行名稱不能為空', 'branchname')
                        else if (this.branchcode == '') alertError('分行代碼不能為空', 'branchcode')
                        else if ($('#accpid').val() == 'Y' && this.accountPID == '') alertError('請輸入銀行帳戶身分證字號', 'accountPID')
                        // else if ($('#accpid').val() == 'Y' && !isPid.test(this.accountPID)) alertError('身分證字號格式有誤', 'accountPID')
                        else if ($('#accpbirth').val() == 'Y' && this.regpbirth == '') alertError('請輸入銀行帳戶出生年月日', 'regpbirth')
                        else if (this.newppass == '') alertError('提款密碼不能為空', 'newppass')
                        else if (this.newppass.length < 4 || this.newppass.length > 10) alertError('提款密碼僅限4到10個英文及數字', 'newppass')
                        else if (this.chknewppass == '') alertError('確認提款密碼不能為空', 'chknewppass')
                        else if (this.newppass != this.chknewppass) alertError('確認提款密碼輸入不一致', 'chknewppass');
                        else if ( $(`.${this.bankform} input[name='IDCard']`).val()== "") {this.checkError('Bank_IDCard', '請上傳證件圖片');}
                        else if ( $(`.${this.bankform} input[name='IDCardBackImg']`).val()== "") {this.checkError('Bank_IDCardBackImg', '請上傳證件反面圖片');}
                        else if ( $(`.${this.bankform} input[name='DepositBook']`).val()== "") {this.checkError('Bank_DepositBook', '請上傳身分證存摺同框圖片');}
                        else {
                            this.updateBank()
                        }
                    } else {
                        if (this.account_name == '') alertError('銀行戶名不能為空', 'account_name')
                        else if (this.bankname == '0') alertError('請選擇銀行名稱', 'bankname')
                        else if (this.bankaccount == '') alertError('銀行帳號不能為空', 'bankaccount')
                        else if (this.bankaccount.length < 10 || this.bankaccount.length > 19) alertError('銀行帳號僅限10到19個數字', 'bankaccount')
                        else if (this.branchname == '') alertError('分行名稱不能為空', 'branchname')
                        else if (this.branchcode == '') alertError('分行代碼不能為空', 'branchcode')
                        else if ($('#accpid').val() == 'Y' && this.accountPID == '') alertError('請輸入銀行帳戶身分證字號', 'accountPID')
                        // else if ($('#accpid').val() == 'Y' && !isPid.test(this.accountPID)) alertError('身分證字號格式有誤', 'accountPID')
                        else if ($('#accpbirth').val() == 'Y' && this.regpbirth == '') alertError('請輸入銀行帳戶出生年月日', 'regpbirth');
                        else if ( $(`.${this.bankform} input[name='IDCard']`).val()== "") {this.checkError('Bank_IDCard', '請上傳證件圖片');}
                        else if ( $(`.${this.bankform} input[name='IDCardBackImg']`).val()== "") {this.checkError('Bank_IDCardBackImg', '請上傳證件反面圖片');}
                        else if ( $(`.${this.bankform} input[name='DepositBook']`).val()== "") {this.checkError('Bank_DepositBook', '請上傳身分證存摺同框圖片');}
                        else {
                            this.updateBank()
                        }
                    }
                }
                if (i == 'jsbank_add_usdt') {
                    this.bankform = 'addUsdt';
                    sw_user_usdt_depositbook = typeof sw_user_usdt_depositbook == 'undefined'?  'N': sw_user_usdt_depositbook;
                    //通道戶名
                    if (this.account_name_usdt == '') this.checkError('account_name_usdt', '通道戶名不能為空')
                    else if (!isChinese.test(this.account_name_usdt)) this.checkError('account_name_usdt', '通道戶名僅限中文')
                    else this.checkTrue('account_name_usdt')
                    //通道類型
                    if (this.bankname_usdt == '0') this.checkError('bankname_usdt', '請選擇通道類型')
                    else this.checkTrue('bankname_usdt')
                    //通道地址
                    if (this.bankaccount_usdt == '') this.checkError('bankaccount_usdt', '通道地址不能為空')
                    else if (bankCode == "TRC20" && this.bankaccount_usdt.length != 34 && !isUsdt.test(this.bankaccount_usdt)) this.checkError('bankaccount_usdt', '僅限開頭為T的34個英文或數字。')
                    else if (bankCode == "ERC20" && this.bankaccount_usdt.length != 42 && !isUsdt.test(this.bankaccount_usdt)) this.checkError('bankaccount_usdt', '僅限開頭為0x的42個英文或數字。')
                    else this.checkTrue('bankaccount_usdt')

                    if ($('#uBankCF').val() == 0 && $('#usUsdt').val() == 0) {
                        //提款密碼
                        if (this.newppass_usdt == '') this.checkError('newppass_usdt', '提款密碼不能為空')
                        else if (this.newppass_usdt.length < 4 || this.newppass_usdt.length > 10) this.checkError('newppass_usdt', '僅限4到10個英文及數字')
                        else this.checkTrue('newppass_usdt')
                        //確認密碼
                        if (this.chknewppass_usdt == '') this.checkError('chknewppass_usdt', '確認提款密碼不能為空')
                        else if (this.newppass_usdt != this.chknewppass_usdt) this.checkError('chknewppass_usdt', '確認提款密碼輸入不一致')
                        else this.checkTrue('chknewppass_usdt')

                        if (this.account_name_usdt == '') alertError('通道戶名不能為空', 'account_name_usdt')
                        else if (this.bankname_usdt == '0') alertError('請選擇通道類型', 'bankname_usdt')
                        else if (this.bankaccount_usdt == '') alertError('通道地址不能為空', 'bankaccount_usdt')
                        else if ( $(`.${this.bankform} input[name='DepositBook']`).val()== "" && sw_user_usdt_depositbook =="Y") {this.checkError('USDT_DepositBook', '請上傳通道錢包的圖片')}
                        else if (bankCode == "TRC20" && this.bankaccount_usdt.length != 34 && !isUsdt.test(this.bankaccount_usdt)) alertError('僅限開頭為T的34個英文或數字。', 'bankaccount_usdt')
                        else if (bankCode == "ERC20" && this.bankaccount_usdt.length != 42 && !isUsdt.test(this.bankaccount_usdt)) alertError('僅限開頭為0x的42個英文或數字。', 'bankaccount_usdt')
                        else if (this.newppass_usdt == '') alertError('提款密碼不能為空', 'newppass_usdt')
                        else if (this.newppass_usdt.length < 4 || this.newppass_usdt.length > 10) alertError('提款密碼僅限4到10個英文及數字', 'newppass_usdt')
                        else if (this.chknewppass_usdt == '') alertError('確認提款密碼不能為空', 'chknewppass_usdt')
                        else if (this.newppass_usdt != this.chknewppass_usdt) alertError('確認提款密碼輸入不一致', 'chknewppass_usdt')
                        else {
                            this.updateUsdt()
                        }
                    } else {
                        if (this.account_name_usdt == '') alertError('通道戶名不能為空', 'account_name_usdt')
                        else if (this.bankname_usdt == '0') alertError('請選擇通道類型', 'bankname_usdt')
                        else if (this.bankaccount_usdt == '') alertError('通道地址不能為空', 'bankaccount_usdt')
                        else if ( $(`.${this.bankform} input[name='DepositBook']`).val()== "" && sw_user_usdt_depositbook =="Y") {this.checkError('USDT_DepositBook', '請上傳通道錢包的圖片')}
                        else if (bankCode == "TRC20" && (this.bankaccount_usdt.length != 34 || !isUsdt.test(this.bankaccount_usdt))) alertError('僅限開頭為T的34個英文或數字。', 'bankaccount_usdt')
                        else if (bankCode == "ERC20" && (this.bankaccount_usdt.length != 42 || !isUsdt.test(this.bankaccount_usdt))) alertError('僅限開頭為0x的42個英文或數字。', 'bankaccount_usdt')
                        else if ($('#accpbirth').val() == 'Y' && this.regpbirth == '') alertError('請輸入銀行帳戶出生年月日', 'regpbirth')
                        else {
                            this.updateUsdt()
                        }
                    }
                }
                if (i == "jsbank_add_cvs") {
                    this.bankId = $("#jsbankform_cvs select[name=bankId]").val()
                    if (this.bankId == '') {
                        alertError('請選擇超商', 'bankId');
                        return false;
                    }
                    if (this.bankcounty == '') {
                        alertError('縣市不能為空', 'bankcounty');
                        return false;
                    }
                    if (this.bankdistrict == '') {
                        alertError('鄉鎮市區不能為空', 'bankdistrict');
                        return false;
                    }

                    sw_cvs_branchcode = typeof sw_cvs_branchcode == 'undefined'?  'N': sw_cvs_branchcode;
                    sw_cvs_bankbranch = typeof sw_cvs_bankbranch == 'undefined'?  'N': sw_cvs_bankbranch;
                    if (this.branchcode2 == '' && sw_cvs_branchcode =="Y") {
                        alertError('店號不能為空', 'branchcode2');
                        return false;
                    }
                    if (this.branchcode2.length > 10) {
                        alertError('限10個數字內', 'branchcode2');
                        return false;
                    }
                    if (this.bankbranch == '' && sw_cvs_bankbranch =="Y") {
                        alertError('店名不能為空', 'bankbranch');
                        return false;
                    }
                    this.addCVSArea();
                }
                if (i == 'jsbank_add_ccd') {
                    this.bankform = 'addCCD';
                    sw_user_ccd_identification = typeof sw_user_ccd_identification == 'undefined' ?  'N': sw_user_ccd_identification;
                    sw_user_ccd_idcardbackimg  = typeof sw_user_ccd_idcardbackimg == 'undefined'  ?  'N': sw_user_ccd_idcardbackimg;
                    sw_user_ccd_depositbook    = typeof sw_user_ccd_depositbook == 'undefined'    ?  'N': sw_user_ccd_depositbook;
                    sw_user_ccd_depositbackbook    = typeof sw_user_ccd_depositbackbook == 'undefined'    ?  'N': sw_user_ccd_depositbackbook;

                    //通道戶名
                    if (this.account_name_ccd == '') this.checkError('account_name_ccd', '持卡人不能為空')
                    else if (!isChinese.test(this.account_name_ccd)) this.checkError('account_name_ccd', '持卡人僅限中文')
                    else this.checkTrue('account_name_ccd')
                    //類型
                    if (this.bankname_ccd == '0') this.checkError('bankname_ccd', '請選擇銀行')
                    else this.checkTrue('bankname_ccd')
                    //地址
                    if (this.bankaccount_ccd == '') this.checkError('bankaccount_ccd', '信用卡卡號不能為空')
                    else this.checkTrue('bankaccount_ccd')


                    if (this.account_name_ccd == '') alertError('持卡人不能為空', 'account_name_ccd')
                    else if (this.bankname_ccd == '0') alertError('請選擇銀行', 'bankname_ccd')
                    else if (this.bankaccount_ccd == '') alertError('信用卡卡號不能為空', 'bankaccount_ccd')
                    else if ( $(`.${this.bankform} input[name='IDCard']`).val()== "" && sw_user_ccd_identification =="Y") {this.checkError('USDT_IDCard', '請上傳身分證圖片')}
                    else if ( $(`.${this.bankform} input[name='IDCardBackImg']`).val()== "" && sw_user_ccd_idcardbackimg =="Y") {this.checkError('USDT_IDCardBackImg', '請上傳身分證背面圖片')}
                    else if ( $(`.${this.bankform} input[name='DepositBook']`).val()== "" && sw_user_ccd_depositbook =="Y") {this.checkError('addCCD_DepositBook', '請上傳信用卡圖片')}
                    else if ( $(`.${this.bankform} input[name='DepositBackBook']`).val()== "" && sw_user_ccd_depositbackbook =="Y") {this.checkError('addCCD_DepositBackBook', '請上傳信用卡背面圖片')}
                    else {
                        this.updateCCD()
                    }
                }
                if (i == 'jsbank_img') {
                    this.bankform = 'updateBank';
                    this.updateBankImg = 'Y';
                    this.bankname = $('#banksel').find(':selected').data('bankid')
                    this.bankaccount = $('#banksel').find(':selected').data('bank')
                    this.branchname = $('#banksel').find(':selected').data('branch')
                    this.branchcode = $('#banksel').find(':selected').data('branchcode')
                    this.accname = $('#banksel').find(':selected').data('accname')
                    this.newppass = '';
                    this.chknewppass = '';
                    this.updateBank();
                }
                if (i == 'ccd_jsbank_img') {
                    this.UBID = $("#ccdsel").val();
                    this.bankform = 'linkCCD';
                    this.bankname_ccd = $('#ccdsel').find(':selected').data('bankid')
                    this.updateCCD();
                }
                if (i == 'usdt_jsbank_img') {
                    this.bankform         = 'linkUsdt';
                    this.updateBankImg    = 'Y';
                    this.bankname_usdt    = $('#usdtsel').find(':selected').data('bankid')
                    this.bankaccount_usdt = $('#usdtsel').find(':selected').data('bank')
                    this.accname          = $('#usdtsel').find(':selected').data('accname')
                    this.updateUsdt();
                }
                //站內信
                if (i == 'send') {
                    //標題
                    if (this.sendtitle == '') this.checkError('sendtitle', '標題不能為空')
                    else this.checkTrue('sendtitle')
                    //訊息內容
                    if (this.sendcontent == '') {
                        this.checkError('sendcontent', '訊息內容不能為空')
                        $('.textarea-block').addClass('error-focus')
                    } else {
                        this.checkTrue('sendcontent')
                        $('.textarea-block').removeClass('error-focus')
                    }

                    if (this.sendtitle == '') alertError('標題不能為空', 'sendtitle')
                    else if (this.sendcontent == '') {
                        $(`.textarea-block`).focus();
                        alertError('訊息內容不能為空')
                    }
                    else {
                        this.sendmessage()
                    }
                }
                //點數儲值
                if (i == 'deposit') {
                    let bankBranch = $('#AccID').find(':selected').data('bankbranch');
                    if (!ubidreq) {
                        $(`#depositform select[name='UBID']`).val("0")
                    }
                    //存款類型
                    if (this.depositselect == "0") {
                        this.checkError('depositselect', '請選擇存款類型')
                        $(`select[name=AccID]`).addClass('error-focus');
                    }
                    else {
                        this.checkTrue('depositselect')
                        $(`select[name=AccID]`).removeClass('error-focus');
                    }
                    //儲值金額
                    if (this.amount == '') {
                        this.checkError('amount', '請填入此欄位')
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else if (this.amount < parseInt($('#p_min').text())) {
                        this.checkError('amount', `最低儲值金額:${$('#p_min').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else if (this.amount > parseInt($('#p_max').text())) {
                        this.checkError('amount', `最高儲值金額:${$('#p_max').text()}`)
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else if ($(`#rulecondition`).val() !='' && new RegExp($(`#rulecondition`).val().replace(/^\/|\/$/g, '')).test(this.amount)) {
                        this.checkError('amount', $(`#rulemsg`).val())
                        $(`input[name=Amount]`).addClass('error-focus');
                    }
                    else {
                        this.checkTrue('amount')
                        $(`select[name=Amount]`).removeClass('error-focus');
                    }

                    if(acctype == 'deposit' && exchange == 1){
                        this.remark =  $('#bankInput').val();
                        $(`#depositform input[name="Remark"]`).val(this.remark);
                        $('select[name="Remark"]').append('<option value="'+ this.remark+'">'+ this.remark+'</option>');
                        $('select[name="Remark"]').val(this.remark);
                    }

                    //銀行地址末五碼或通道地址
                    if (this.remark == '' && acctype == 'deposit') {
                        this.checkError('remark', '請填入此欄位')
                        $(`input[name=Remark]`).addClass('error-focus');
                    }
                    else {
                        this.checkTrue('remark')
                        $(`select[name=Remark]`).removeClass('error-focus');
                    }
                    let ubid = $(`select[name='UBID']`).val();
                    let branch = $("#AccID :selected").data('bankbranch');
                    if (this.depositselect == "0") alertError('請選擇存款類型')
                    else if (payset && !matchingpayset) {
                        alertError("請先綁定超商"+bankname)
                    }
                    else if (ubidreq && ubid == "0") {
                        if (branch == "CVS") {
                            msg = "指定超商不能為空";
                        } else if (branch == "CCD") {
                            msg = "指定信用卡不能為空";
                        }  else {
                            msg = "指定銀行不能為空";
                        }
                        alertError(msg)
                    }
                    else if (this.amount == '') alertError('儲值金額不能為空', 'Amount')
                    else if (ubidreq && ubid == "0") alertError('指定銀行不能為空')
                    else if (this.amount < parseInt($('#p_min').text())) alertError(`最低儲值金額：${parseInt($('#p_min').text())}`, 'Amount')
                    else if (this.amount > parseInt($('#p_max').text())) alertError(`最高儲值金額：${parseInt($('#p_max').text())}`, 'Amount')
                    else if ($(`#rulecondition`).val() !='' && new RegExp($(`#rulecondition`).val().replace(/^\/|\/$/g, '')).test(this.amount)) {
                        alertError($(`#rulemsg`).val())
                    }
                    else if (this.remark == '' && acctype == 'deposit' && exchange != 1) alertError('通道地址不能為空', 'Remark')
                    else if (this.remark == '' && acctype == 'deposit' && exchange == 1) alertError('銀行地址末五碼不能為空', 'Remark')
                    else if (this.remark.length != 5 && acctype == 'deposit' && exchange == 1) alertError('請輸入銀行地址末五碼', 'Remark')
                    else {
                        if (branch == "CVS" && user_cvs < 1) {
                            Swal.fire({
                                title: '請綁定超商地區',
                                icon: 'info',
                                html: '<div style="font-size:1.1rem">儲值前請先綁定超商地區</div>'
                            }).then(function () {
                                location.href = "./jsbank";
                            });
                        } else {
                            this.submitPaygate()
                        }
                    }
                }
                //點數轉移
                if (i == 'transfer') {
                    //轉出
                    if (this.transferfrom == "請選擇") this.checkError('transferfrom', '請填入此欄位')
                    else this.checkTrue('transferfrom')
                    //轉入
                    if (this.transferto == '請選擇') this.checkError('transferto', '請填入此欄位')
                    else this.checkTrue('transferto')
                    //金額
                    if (this.amount == '') {
                        this.checkError('amount', '請填入此欄位')
                        $(`input[name=transferamount]`).addClass('error-focus');
                    }
                    else if (this.amount < 1) {
                        this.checkError('amount', '金額不得小於1')
                        $(`input[name=transferamount]`).addClass('error-focus');
                    }
                    else {
                        //最大額度
                        if(this.amount > parseInt($('#max_transfer').val()) && this.transferfrom != "請選擇") {
                            this.checkError('amount', `最大額度: ${parseInt($('#max_transfer').val())}`)
                            $(`input[name=transferamount]`).addClass('error-focus');
                        } else {
                            this.checkTrue('amount')
                            $(`input[name=transferamount]`).removeClass('error-focus');
                        }
                    }
                    if (this.transferfrom == "請選擇") alertError('轉出欄位不能為空')
                    else if (this.transferto == '請選擇') alertError('轉入欄位不能為空')
                    else if (this.amount == '') alertError('金額不能為空', 'amount')
                    else if (this.amount < 1) alertError('金額不得小於1', 'amount')
                    else if (this.amount > parseInt($('#max_transfer').val()) && this.amount != '') alertError(`最大額度: ${parseInt($('#max_transfer').val())}`, 'amount')
                    else {
                        this.saveTransfer()
                    }
                }
                //點數提領
                if (i == 'jswithdraw') {
                    //提領金額
                    if (this.pamount == '') {
                        this.checkError('pamount', '請填入提領金額')
                        $(`input[name=amount]`).addClass('error-focus');
                    }
                    else if (parseInt(this.pamount) > parseInt($('#uUserBalance').val())) {
                        this.checkError('pamount', `最高提領金額:${parseInt($('#uUserBalance').val())}`)
                        $(`input[name=amount]`).addClass('error-focus');
                    }
                    else if (parseInt(this.pamount) < parseInt(this.miniWD)) {
                        this.checkError('pamount', `最低提領金額:${parseInt(this.miniWD)}`)
                        $(`input[name=amount]`).addClass('error-focus');
                    }
                    else {
                        this.checkTrue('pamount')
                        $(`input[name=amount]`).removeClass('error-focus');
                    }
                    //當前提款密碼
                    if (this.oldppass == '') {
                        this.checkError('oldppass', '提領密碼不能為空')
                        $(`input[name=bankPass]`).addClass('error-focus');
                    }
                    else if (this.oldppass.length < 4 || this.oldppass.length > 10) {
                        this.checkError('oldppass', '僅限4到10個英文與數字')
                        $(`input[name=bankPass]`).addClass('error-focus');
                    }
                    else {
                        this.checkTrue('oldppass')
                        $(`input[name=bankPass]`).removeClass('error-focus');
                    }

                    if (this.pamount == '') alertError('提領金額不能為空', 'amount')
                    else if (parseInt(this.pamount) > parseInt($('#uUserBalance').val())) alertError(`最高提領金額:${parseInt($('#uUserBalance').val())}`, 'amount')
                    else if (parseInt(this.pamount) < parseInt(this.miniWD)) alertError(`最低提領金額:${parseInt(this.miniWD)}`, 'amount')
                    else if (this.oldppass == '') alertError('提領密碼不能為空', 'bankPass')
                    else if (this.oldppass.length < 4 || this.oldppass.length > 10) alertError('提領密碼僅限4到10個英文及數字', 'bankPass')
                    else {
                        this.withdrawal()
                    }
                }
                //修改生日
                if (i == 'regpbirth') {
                    if (this.regpbirth == '') this.checkError('regpbirth', '生日不能為空')
                    else this.checkTrue('regpbirth')
                    if (this.regpbirth == '') alertError('請輸入生日', 'regpbirth')
                    else{
                        this.changebirth()
                    }
                }
            },
            //忘記密碼驗證
            forgetForm(num) {
                if (num == 2) {
                    this.userID = ''
                    //帳號
                    if (this.account == '') this.checkError('account', '帳號不能為空')
                    else if (!accRegular.regular.test(this.account)) this.checkError('account', accRegular.regularMsg);
                    else this.checkTrue('account')
                    //手機
                    if (this.phone == '') this.checkError('phone', '手機不能為空')
                    else if (this.phone.length < 10) this.checkError('phone', '手機僅限10碼')
                    else if (!isMobile.test(this.phone)) this.checkError('phone', '請輸入有效的手機號碼')
                    else this.checkTrue('phone')
                    //驗證碼
                    if (this.Verificationcode == '') this.checkError('Verificationcode', '驗證碼不能為空')
                    else this.checkTrue('Verificationcode')

                    if (this.account == '') alertError('帳號不能為空', 'account')
                    else if (!accRegular.regular.test(this.account)) this.checkError(accRegular.regularMsg, 'account');
                    else if (this.phone == '') alertError('手機不能為空', 'phone')
                    else if (this.phone.length < 10) alertError('手機僅限10碼', 'phone')
                    else if (!isMobile.test(this.phone)) alertError('請輸入有效的手機號碼', 'phone')
                    else if (this.Verificationcode == '') alertError('驗證碼不能為空', 'Verificationcode')
                    else {
                        $('.forgetNav a').removeClass('active')
                        $(`.forgetNav a:nth-child(${num})`).addClass('active')
                        $("#top1").hide()
                        $(`#top${num}`).show()
                    }
                }
                if (num == 3) {
                    //密碼
                    if (this.password == '') this.checkError('password', '密碼不能為空')
                    else if (this.password.length < 6 || this.password.length > 20) this.checkError('password', '僅限6到20個英文及數字')
                    else this.checkTrue('password')
                    //確認密碼
                    if (this.chkpassword == '') this.checkError('chkpassword', '確認密碼不能為空')
                    else if (this.password != this.chkpassword) this.checkError('chkpassword', '確認密碼輸入不一致')
                    else this.checkTrue('chkpassword')

                    if (this.password == '') alertError('密碼不能為空', 'password')
                    else if (this.password.length < 6 || this.password.length > 20) alertError('密碼僅限6到20個英文及數字', 'password')
                    else if (this.chkpassword == '') alertError('確認密碼不能為空', 'chkpassword')
                    else if (this.password != this.chkpassword) alertError('確認密碼輸入不一致', 'chkpassword')
                    else {
                        axios.post('./password.php', Qs.stringify({
                            a: 'resetPword',
                            newpword: this.password,
                            cknewpword: this.chkpassword,
                            account: this.account,
                            sphone: this.phone,
                            Verificationcode: this.Verificationcode
                        }))
                        .then(res => {
                            if (res.data.success == 0) {
                                Swal.fire(res.data.msg, "", 'info').then(function(){
                                    $('.forgetNav a').removeClass('active')
                                    $(`.forgetNav a:nth-child(${num})`).addClass('active')
                                    $("#top2").hide()
                                    $(`#top${num}`).show()
                                })
                            } else {
                                switch(res.data.success){
                                    case -1:
                                        alertError(res.data.msg, 'password')
                                    break;
                                    case -2:
                                        alertError(res.data.msg, 'chkpassword')
                                    break;
                                    default:
                                        $('.forgetNav a').removeClass('active')
                                        $(`.forgetNav a:nth-child(1)`).addClass('active')
                                        $("#top2").hide()
                                        $(`#top1`).show();
                                        let focus_map = {"11":"account", "21":"phone", "3":"Verificationcode", "4": "phone"};
                                        alertError(res.data.msg, focus_map[res.data.success*-1]||"");
                                    break;
                                }
                            }
                        })
                        .catch(err => {
                        })
                    }
                }
            },
            /**
             * 
             * @param {*} name 正確input name
             */
            checkTrue(name) {
                this[`${name}No`] = false;
                $(`input[name=${name}]`).removeClass('error-focus');
                $(`select[name=${name}]`).removeClass('error-focus');
            },
            /**
            * 
            * @param {*} name 錯誤input name
            * @param {*} err 錯誤提示字
            */
            checkError(name, err) {
                this[`${name}No`] = true;
                $(`#${name}Error, #upd_${name}Error`).text(err)
                $(`input[name=${name}]`).addClass('error-focus');
                $(`select[name=${name}]`).addClass('error-focus');
            },
            //清除表單
            resetForm(name) {
                Object.assign(this.$data, this.$options.data());
                this.$nextTick(function () {
                    $("input, select").removeClass('error-focus');
                    this.accounthNo = false;
                    this.passwordhNo = false;
                    this.accountNo = false;
                    this.passwordNo = false;
                    this.chkpasswordNo = false;
                    this.captchaNo = false;
                    this.usernameNo = false;
                    this.regpbirthNo = false;
                    this.phoneNo = false;
                    this.lineNo = false;
                    this.accountPIDNo = false;
                    this.VerificationcodeNo = false;
                    this.oldupassNo = false;
                    this.oldppassNo = false;
                    this.newppassNo = false;
                    this.chknewppassNo = false;
                    this.sendtitleNo = false;
                    this.sendcontentNo = false;
                    this.account_nameNo = false;
                    this.banknameNo = false;
                    this.branchnameNo = false;
                    this.branchcodeNo = false;
                    this.bankaccountNo = false;
                    this.depositselectNo = false;
                    this.bankselectNo = false;
                    this.amountNo = false;
                    this.amountUsdtNo = false;
                    this.remarkNo = false;
                    this.transferfromNo = false;
                    this.transfertoNo = false;
                    this.pamountNo = false;
                    this.min_withdraw = false;
                    this.max_withdraw = false;
                    this.Bank_IDCardNo = false,
                    this.Bank_IDCardBackImgNo = false,
                    this.USDT_DepositBookNo = false,
                    this.Bank_DepositBookNo = false
                    $("input[name=amountUsdt]").val('')
                });
            },
            //登入
            login() {
                $('.loading_block').show();
                $(".loginHref").prop("disabled", true);
                $(".form-btn button").prop("disabled", true);
                axios.post("/login", Qs.stringify({
                    'a': 'login',
                    'Account': this.accounth,
                    'Password': this.passwordh,
                    'VCode': this.captcha,
                    'Device': (typeof use_device !== 'undefined' ? use_device : ""),
                    '_csrf_token': $('input[name="_csrf_token"]').val()
                }))
                    .then(res => {
                        $(".loginHref").prop("disabled", false);
                        $(".form-btn button").prop("disabled", false);
                        if (res.data.success == 0) {
                            location.href = "./index";
                        } else {
                            $('.loading_block').fadeOut();
                            if (res.data.msg == '驗證碼錯誤') {
                                $(".captcha").click();
                                this.captcha = ''
                                alertError(res.data.msg, 'captcha');
                            }
                            else if (res.data.success == -2) {
                                $(".captcha").click();
                                this.resetForm('login')
                                alertError(res.data.msg, 'accounth');
                            }
                            else {
                                Swal.fire(res.data.msg, '', 'error').then(function () {
                                    $('.captcha').click();
                                });
                            }
                        }
                    })
                    .catch(err => {
                    })
            },
            //註冊
            register() {
                if (this.regneedpbrth && this.regneedpbrth === "Y") {
                    var today = new Date().getTime();
                    var todayts = Math.floor(today / 1000);
                    var pbirth = new Date(this.regpbirth).getTime();
                    var pbirthts = Math.floor(pbirth / 1000);
                    if (todayts - pbirthts < 568080000) {
                        this.checkError('regpbirth', '年齡未滿18歲')
                        alertError('【年齡限制：本公司只接受年齡已滿18歲的註冊用戶。】', 'regpbirth')
                        return false;
                    }
                }
                $('.loading_block').show();
                axios.post("/registration_act",Qs.stringify({
                    a: "add",
                    Name: this.username,
                    Account: this.account,
                    Password: this.password,
                    ChkPassword: this.chkpassword,
                    regpbirth: this.regpbirth,
                    Phone: this.phone,
                    Line: this.line,
                    agcode: $('#agcode').val() ? $('#agcode').val(): '',
                    Verificationcode: this.Verificationcode,
                    Device: (typeof use_device !== 'undefined' ? use_device : ""),
                }))
                .then(res => {
                    this.register_submit = false;
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        Swal.fire(res.data.msg,"", "success").then(function () {
                            location.href = "./";
                            $('.loading_block').show();
                        });
                    } else {
                        $('.loading_block').fadeOut();
                        alertError(res.data.msg)
                    }
                })
                .catch(err => {
                    this.register_submit = false;
                })
            },
            // 註冊表單帳號姓名電話驗證
            registerCheck() {
                let self = this;
                $(`#regForm input[name=account]`).focusout(function () {
                    if (accRegular.regular.test(self.account)) {
                        let ckcont = $(this).val();
                        self .regCheck('account', ckcont)
                    }
                });
            },
            regCheck(ckfield, ckcont) {
                if ($("#forget_password-phone").length > 0) {
                    $(".sendActbtn").prop('disabled', false).removeClass("disabled")
                    return false;
                }

                axios.post("/registration_act", Qs.stringify({
                    'a': "ck" + ckfield,
                    'ckcont': ckcont,
                }))
                .then(res => {
                    if (res.data.success == -1) {
                        $(`input[name=${ckfield}]`).focus();
                        this.checkError(ckfield, res.data.msg)
                        if (ckfield == "phone") $(".sendActbtn").prop('disabled', true).addClass("disabled");
                    } else {
                        this.checkTrue(ckfield)
                        if (ckfield == "phone") $(".sendActbtn").prop('disabled', false).removeClass("disabled");
                    }
                })
                .catch(err => {
                })
            },
            //修改登入密碼
            resetupass() { 
                $('.loading_block').show();
                $('#upassreset').prop('disabled', true);
                axios.post('../../member_act.php', Qs.stringify({
                    a: 'updatePass',
                    Oldpassword: this.oldupass,
                    Newpassword: this.password,
                    Newchkpassword: this.chkpassword
                }))
                .then((res)=>{
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        $('#upassreset').prop('disabled', false);
                        Swal.fire(res.data.msg, '', 'success').then(function(){
                            location.href = './logout';
                            $('.loading_block').show();
                        });
                    } else {
                        $('.loading_block').fadeOut();
                        $('#upassreset').prop('disabled', false);
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                        this.resetForm('member')
                    }
                })
                .catch((err)=>{
                    $('#upassreset').prop('disabled', false);
                })
            },
            //儲值
            submitPaygate() {
                let self = this;
                let warning = "";
                let bankBranch = $('#AccID').find(':selected').data('bankbranch');
                let acctype = $('#AccID').find(':selected').data('acctype');
                let bankacc = $('#AccID').find(':selected').data('bankacc');
                let bankname = $('#AccID').find(':selected').data('bankname');
                let bankcode = $('#AccID').find(':selected').data('bankcode');
                let currency = $('#AccID').find(':selected').data('currency');
                let usdt = $("input[name=amountUsdt]").val()

                if (bankBranch == "CVS") warning = `<span style="color: red; font-weight: bold; font-size: 22px;">超商充值請向客服提供繳款明細及身份証拍照認証</span>`;
                if (acctype == "deposit") {
                    if (currency == "USDT") {
                        warning = `
                            <h1>${usdt}<span style="font-size:20px; margin-left:10px;">USDT</span></h1>
                            <h3>${bankcode} 儲值錢包地址</h3>
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap; border: solid 1px gray; border-radius: 5px; padding: 5px;">
                                <textarea id="bankaccCopy" style="width: calc(100% - 65px); text-align: left; border: none; resize: none;" readonly>${bankacc}</textarea>
                                <button class="btn btn-primary btn-sm" style="width: 52px; white-space: nowrap; margin-right: 3px;" onclick="copyAcc()">複製</button>    
                            </div>
                            <div style="height: 50px;">
                                <p id="copySucc" style="display: none; color: green;">複製成功</p>
                            </div>
                        `;
                    } else {
                        warning = `
                            <h3>${bankname}(${bankcode}) 銀行帳號</h3>
                            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; flex-wrap: nowrap; border: solid 1px gray; border-radius: 5px; padding: 5px;">
                                <textarea id="bankaccCopy" style="width: calc(100% - 65px); text-align: left; border: none; resize: none;" readonly>${bankacc}</textarea>
                                <button class="btn btn-primary btn-sm" style="width: 52px; white-space: nowrap; margin-right: 3px;" onclick="copyAcc()">複製</button>    
                            </div>
                            <div style="height: 50px;">
                                <p id="copySucc" style="display: none; color: green;">複製成功</p>
                            </div>
                        `;
                    }
                }
                var _data = $('form[name="depositform"]').serialize();
                $('#storeBtn').prop('disabled', true);
                $('.loading_block').show()
                axios.post('../../member_act.php', _data)
                .then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut()
                        $('#storeBtn').prop('disabled', false);
                        $('.mycash').hide()
                        Swal.fire({
                            title: res.data.msg, 
                            html: warning,
                            icon: 'success',
                            allowOutsideClick: false,
                        }).then(function () {
                            self.resetForm('deposit')
                            if(acctype == 'dpay') {
                                window.open(`./thirdparty_pay.php?tp=${res.data.data.ThirdParty}&pid=${res.data.data.TradeID}`);
                            } else {
                                location.href = './deposit';
                            }
                        })
                    } else {
                        $('.loading_block').fadeOut()
                        $('#storeBtn').prop('disabled', false);
                        this.resetForm('deposit')
                        $('.mycash').hide()
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            case -2:
                                Swal.fire(res.data.msg, '', 'error').then(function () {
                                    location.reload();
                                    $('.loading_block').show();
                                })
                                break;
                            case -3:
                                Swal.fire(`儲值金額低於優惠最小存款金額 ${res.data.msg}`, "", 'error').then(function(){
                                    $('#PaygateAmount-error').empty().append(`最低優惠存款金額 ${res.data.msg}`).show();
                                });
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                    }
                })
                .catch(err => {
                    $('#storeBtn').prop('disabled', false);
                })
            },
            //點數轉移
            saveTransfer() {   
                var self = this;
                $('#t_confirm').prop('disabled', true)
                $('#t_all').prop('disabled', true)            
                $('.loading_block').show();
                var _form = $("#transferfrom").val();
                var _to = $("#transferto").val();
                var transferamount = $("#transferamount").val();
                if (_form == _to) {
                    $('.loading_block').fadeOut()
                    alertError("請選擇不同館別")
                    $('#t_confirm').prop('disabled', false)
                    return false;
                }
                if (_form != "Master" && _to != "Master") {
                    $(`#${_form}`).val('讀取中')
                    $(`#Master`).val('讀取中')
                    axios.post('../../member_act.php', Qs.stringify({
                        a: 'saveTransfer',
                        from: _form,
                        to: 'Master',
                        amount: transferamount
                    }))
                    .then(res => {
                        if (res.data.success == 0) {
                            axios.post('../../member_act.php', Qs.stringify({
                                a: 'saveTransfer',
                                from: 'Master',
                                to: _to,
                                amount: transferamount
                            }))
                            .then(res => {
                                if (res.data.success == 0) {
                                    $('.loading_block').fadeOut();
                                    Swal.fire(res.data.msg, "", "success");
                                    self.$refs.updateWallet.getWallet();
                                    $('#t_confirm').prop('disabled', false)
                                    $('#t_all').prop('disabled', false)           
                                } else {
                                    $('.loading_block').fadeOut();
                                    switch (res.data.success) {
                                      case -99999:
                                      case -9999:
                                        if (this.logintype) {
                                          this.logintype = false;
                                          Swal.fire(res.data.msg,"","error").then(function () {
                                            location.href = "./logout";
                                            $('.loading_block').show();
                                          });
                                        }
                                        break;
                                      default:
                                        Swal.fire(res.data.msg + "\n 點數已轉至主錢包", "",  "error").then(function(){
                                            self.$refs.updateWallet.getWallet();
                                        });
                                        break;
                                    }
                                }
                                this.resetForm('transfer')
                            })
                            .catch(err => {
                                $('#t_confirm').prop('disabled', false)
                                $('#t_all').prop('disabled', false)
                            })
                        } else {
                            $('.loading_block').fadeOut();
                            $('#t_confirm').prop('disabled', false)
                            $('#t_all').prop('disabled', false)
                            switch (res.data.success) {
                              case -99999:
                              case -9999:
                                if (this.logintype) {
                                  this.logintype = false;
                                  Swal.fire(res.data.msg, "", "error").then(function () {
                                    location.href = "./logout";
                                    $('.loading_block').show();
                                  });
                                }
                                break;
                              case -2:
                                Swal.fire(res.data.msg, "", "error").then(function() {
                                    self.$refs.updateWallet.getWallet();
                                });
                                break;
                              default:
                                alertError(res.data.msg)
                                break;
                            }
                            this.resetForm('transfer')
                        }
                    })
                    .catch(err => {
                        $('#t_confirm').prop('disabled', false)
                        $('#t_all').prop('disabled', false)
                    })
                } else {
                    $(`#${_to}`).val('讀取中')
                    $(`#${_form}`).val('讀取中')
                    axios.post('../../member_act.php', Qs.stringify({
                        a: 'saveTransfer',
                        from: _form,
                        to: _to,
                        amount: transferamount
                    }))
                    .then(res => {
                        if (res.data.success == 0) {
                            alertSuccess(res.data.msg)
                            self.$refs.updateWallet.getWallet();
                        } else {
                            switch (res.data.success) {
                                case -99999:
                                case -9999:
                                  if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg,"","error").then(function () {
                                      location.href = "./logout";
                                      $('.loading_block').show();
                                    });
                                  }
                                  break;
                                case -2:
                                    Swal.fire(res.data.msg, "", "error").then(function () {
                                        self.$refs.updateWallet.getWallet();
                                    });
                                  break;
                                default:
                                    alertError(res.data.msg)
                                    break;
                            }
                        }
                        $('.loading_block').fadeOut();
                        $('#t_confirm').prop('disabled', false)
                        $('#t_all').prop('disabled', false)
                        this.resetForm('transfer')
                    })
                    .catch(err => {
                        $('#t_confirm').prop('disabled', false)
                        $('#t_all').prop('disabled', false)
                    })
                }
            },
            //一鍵轉回
            retunWallet() {
                this.$refs.updateWallet.AlltoMaster_click();
            },
            //一鍵刷新
            getWallet() {
                this.$refs.updateWallet.getWallet();
            },
            //提款
            withdrawal() {  
                let _data = $("#g_withdrawform").serialize();
                // $("#withdrawform button:submit").attr("disabled", true);
                let TAmount = $("#utAmount").val();
                let TBAmount = $("#utBetAmount").val();
                let uResetDate = $("#uResetDate").val();
                let uWithdrawCT = $("#uWithdrawCT").val();
                let betcompare = $("#betcompare").val();
                let withdraw_limit = $("#withdraw_limit").val();
                if (withdraw_limit === "Y") {
                    if (uWithdrawCT > 0) {
                        alertError("尚有未處理完成之提款單，請聯繫客服!")
                        return false;
                    }
                }
                if (betcompare === "Y") {
                    if (parseInt(TBAmount) < parseInt(TAmount)) {
                        let resAmount = (parseFloat(TAmount) - parseFloat(TBAmount)).toFixed(2);
                        let ctext = "<b>從 " + uResetDate + "</b><br><b>所需碼量不足: " + resAmount + "</b>";
                        Swal.fire("未達打碼量", ctext, "error");
                        return false;
                    }
                } else if (betcompare === "N") {
                    console.log("N" + TAmount);
                }
                $('.loading_block').show()
                axios.post("../../member_act.php", _data)
                .then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut()
                        Swal.fire({
                            icon: 'success',
                            title: res.data.msg,
                            text: '頁面即將更新',
                            showConfirmButton: false,
                            timer: 2000
                        }).then(function () {
                            location.reload();
                            $('.loading_block').show()
                        });
                    } else {
                        switch (res.data.success) {
                            case -2:
                                Swal.fire(res.data.msg, "", "error").then(function () {
                                    location.reload();
                                    $('.loading_block').show();
                                });
                                break;
                            case -3:
                                alertError(res.data.msg)
                                break;
                            case -11:
                                Swal.fire(res.data.msg, "", "error").then(function () {
                                    location.reload();
                                    $('.loading_block').show();
                                });
                                break;
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, "", "error",).then(function () {
                                        location.href = "/logout";
                                    });
                                }
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                        $('.loading_block').fadeOut()
                    }
                    $("#withdrawform button:submit").attr("disabled", false);
                    this.resetForm('jswithdraw')
                })
                .catch(err => {
                })
            },
            // 新增銀行卡
            updateBank() {
                if (this.bankform == 'updateBank') {
                    var accname = this.accname;
                } else {
                    if ($('#sw_ubank_accname').val() == 'N') var accname = $('div[name="account_name"]').text()
                    else var accname = $('input[name="account_name"]').val()
                };
                $('.loading_block').show();
                $(".jsbank_btn").prop("disabled", true);

                axios.post("../../member_act.php", Qs.stringify({
                    a: "updateBank2",
                    bankId: this.bankname,
                    accName: accname,
                    accPid: this.accountPID,
                    accPbirth: this.regpbirth,
                    bankAcc: this.bankaccount,
                    BankProvince: "",
                    BankCounty: "",
                    BankBranch: this.branchname,
                    BranchCode: this.branchcode,
                    NewPin: this.newppass,
                    ChkPin: this.chknewppass,
                    IDCard: $(`.${this.bankform} input[name='IDCard']`).val(),
                    IDCardBackImg: $(`.${this.bankform} input[name='IDCardBackImg']`).val(),
                    DepositBook: $(`.${this.bankform} input[name='DepositBook']`).val(),
                    updateBankImg: this.updateBankImg
                }))
                .then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        Swal.fire("請聯繫客服審核", "透過線上客服審核", "info").then(function () {
                            $('.loading_block').show();
                            location.reload();
                        })
                    } else {
                        switch (res.data.success) {
                          case -99999:
                          case -9999:
                            if (this.logintype) {
                              $('.loading_block').fadeOut();
                              this.logintype = false;
                              Swal.fire(res.data.msg, "", "error").then(function () {
                                location.href = "./logout";
                                $('.loading_block').show();
                              });
                            }
                            break;
                          default:
                            $('.loading_block').fadeOut();
                            if(res.data.msg == "分行名稱限中文") this.checkError('branchname', '分行名稱限中文')
                            alertError(res.data.msg)
                            break;
                        }
                    }
                    $(".jsbank_btn").prop("disabled", false);
                })
                .catch(err => {
                    $(".jsbank_btn").prop("disabled", false);
                })
            },
            // 新增USDT
            updateUsdt() {
                if(this.updateBankImg == 'Y' && $(`.${this.bankform} input[name='DepositBook']`).val() =='' ){
                    Swal.fire('請選擇新增圖片', '', 'error');
                    return false;
                };
                DepositBook = $(`.${this.bankform} input[name='DepositBook']`).val() != ''
                let formData = new FormData();
                formData.append('a', 'addUsdtChnnel');
                formData.append('bankId', this.bankname_usdt);
                formData.append('bankAcc', this.bankaccount_usdt);
                formData.append('NewPin', this.newppass_usdt);
                formData.append('ChkPin', this.chknewppass_usdt);
                formData.append('DepositBook', $(`.${this.bankform} input[name='DepositBook']`).val());
                if (this.updateBankImg == 'Y' ) {
                    accname = this.accname;
                    formData.append('updateBankImg', this.updateBankImg);
                } else {
                    if ($('#sw_ubank_accname').val() == 'N') var accname = $('div[name="account_name_usdt"]').text()
                    else accname = $('input[name="account_name_usdt"]').val()
                }
                formData.append('accName', accname);

                $('.loading_block').show();
                $(".jsbank_btn").prop("disabled", true);

                axios.post("../../member_act.php", 
                    formData,
                    {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }
                )
                .then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        Swal.fire("請聯繫客服審核", "透過線上客服審核", "info").then(function () {
                            $('.loading_block').show();
                            location.reload();
                        })
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    $('.loading_block').fadeOut();
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, "", "error").then(function () {
                                        location.href = "./logout";
                                        $('.loading_block').show();
                                    });
                                }
                                break;
                            default:
                                $('.loading_block').fadeOut();
                                if(res.data.msg == "分行名稱限中文") this.checkError('branchname', '分行名稱限中文')
                                alertError(res.data.msg)
                                break;
                        }
                    }
                    $(".jsbank_btn").prop("disabled", false);
                })
                .catch(err => {
                    $(".jsbank_btn").prop("disabled", false);
                })
            },
            addCVSArea() {
                $('.loading_block').show();
                $(".jsbank_btn").prop("disabled", true);
                axios.post('./member_act', Qs.stringify({
                    a: "addCVSArea",
                    bankId: this.bankId,
                    CVSArea: {
                        "BranchCode": this.branchcode2,
                        "BankBranch": this.bankbranch,
                        "BankCounty": this.bankcounty,
                        "BankDistrict": this.bankdistrict
                    }
                })).then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        Swal.fire("填寫完成 請聯繫24H客服人員 進行綁定超商位置", "", "success").then(function () {
                            $('.loading_block').show();
                            location.reload();
                        })
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                $('.loading_block').fadeOut();
                                this.logintype = false;
                                Swal.fire(res.data.msg, "", "error").then(function () {
                                    location.href = "./logout";
                                    $('.loading_block').show();
                                });
                                }
                                break;
                            default:
                                $('.loading_block').fadeOut();
                                alertError(res.data.msg)
                                break;
                        }
                    }
                    $(".jsbank_btn").prop("disabled", false);
                })
                .catch(err => {
                    $(".jsbank_btn").prop("disabled", false);
                })
            },
                        updateCCD() {
                $('.loading_block').show();
                $(".jsbank_btn").prop("disabled", true);
                axios.post('./member_act', Qs.stringify({
                    a: "bindPaymentCCD",
                    UBID: this.UBID,
                    BankID: this.bankname_ccd,
                    AccountName: this.account_name_ccd,
                    AccountNumber: this.bankaccount_ccd,
                    IDCardImg: $(`.${this.bankform} input[name='IDCard']`).val(),
                    IDCardBackImg: $(`.${this.bankform} input[name='IDCardBackImg']`).val(),
                    DepositBackImg: $(`.${this.bankform} input[name='DepositBackBook']`).val(),
                    DepositImg: $(`.${this.bankform} input[name='DepositBook']`).val()
                })).then(res => {
                    if (res.data.success == 0) {
                        $('.loading_block').fadeOut();
                        Swal.fire("已綁定成功", "", "success").then(function () {
                            $('.loading_block').show();
                            location.reload();
                        })
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                $('.loading_block').fadeOut();
                                this.logintype = false;
                                Swal.fire(res.data.msg, "", "error").then(function () {
                                    location.href = "./logout";
                                    $('.loading_block').show();
                                });
                                }
                                break;
                            default:
                                $('.loading_block').fadeOut();
                                alertError(res.data.msg)
                                break;
                        }
                    }
                    $(".jsbank_btn").prop("disabled", false);
                })
                .catch(err => {
                    $(".jsbank_btn").prop("disabled", false);
                })
            },
            // 修改提款密碼
            resetppass() {
                $('.loading_block').show();
                $('#pinpassreset').prop('disabled', true);
                axios.post('../../member_act.php', Qs.stringify({
                    a:"updateBankPass",
                    OldPin: this.oldppass || "",
                    NewPin: this.newppass,
                    ChkPin: this.chknewppass,
                }))
                .then(res => {
                    $('.loading_block').fadeOut();
                    $('#pinpassreset').prop('disabled', false);
                    if (res.data.success == 0) {
                        Swal.fire(res.data.msg, '', 'success').then(() => {
                            location.reload()
                        })
                    } else {
                        switch (res.data.success) {
                          case -99999:
                          case -9999:
                            if (this.logintype) {
                                this.logintype = false;
                                Swal.fire(res.data.msg, "", 'error').then(function () {
                                location.href = './logout';
                                $('.loading_block').show();
                              })
                            }
                            break;
                          default:
                            Swal.fire(res.data.msg, '', 'error').then(function(){
                                if (res.data.success === -1) {
                                    location.href = './jsbank'
                                    $('.loading_block').show();
                                }
                            });
                            break;
                        }
                    }
                    this.resetForm('jsbank')
                })
                .catch(err => {
                    $('#pinpassreset').prop('disabled', false);
                })
            },
            //修改生日
            changebirth() {  
                $('.loading_block').show();
                axios.post('../../member_act.php', Qs.stringify({
                    a:"updateProfile",
                    uBirthday: this.regpbirth,
                }))
                .then(res => {
                    $('.loading_block').fadeOut();
                    if (res.data.success == 0) {
                        Swal.fire(res.data.msg, "", 'success').then(function () {
                            location.href = './member'
                        })
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, "", 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            default:
                                Swal.fire(res.data.msg, '', 'error').then(function(){
                                    if (res.data.success === -1) {
                                        location.href = './member'
                                        $('.loading_block').show();
                                    }
                                });
                                break;
                        }
                    }
                })
                .catch(err => {
                })
            },
            //切換銀行卡
            changeBank(name) {
                this.$refs.clickbank.toggleNav(name);
            },
            // 站內信- 發送訊息
            sendmessage() { 
                $('.loading_block').show();
                axios.post('../../member_act.php', Qs.stringify({
                    a: 'getInbox',
                    t: 'add',
                    ibTitle: `${$('#c_message_select :selected').text()} : ${this.sendtitle}`,
                    ibContent: this.sendcontent
                }))
                .then(res => {
                    if (res.data.success == 0) {
                        if(  res.data.data && res.data.data.success ){
                            switch( res.data.data.success ){
                                case 19:
                                    alertSuccess('發送成功')
                                    this.$refs.contactus.InboxList();
                                    break;
                                case -19:
                                    alertError('出現問題，請稍後再試! 或請使用 Line客服!')
                                    break;
                            }
                        }
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    $('.loading_block').fadeOut();
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                        }
                    }
                    $('.loading_block').fadeOut()
                    this.resetForm('send')
                })
                .catch(err => {
                })
            },
            //取得站內信數量
            getibacc() {
                var today = new Date();
                var last_week = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000);
                var startData = this.format_time(last_week) + " 00:00:00";
                var endData = this.format_time(today) + " 23:59:59";
                axios.post("../../member_act.php",Qs.stringify({
                    a: 'getInbox',
                    t:'getcount',
                    sd: startData,
                    ed: endData
                }))
                .then(res => {
                    if (res.data.success == 0) {
                        $(".ibacc_sum").text(res.data.data.acc);
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                    }
                })
                .catch(err => {
                })
            },
            format_time(time) {
                time = time.getFullYear() + "-" + this.headertimeformat(time.getMonth() + 1) + "-" + this.headertimeformat(time.getDate());
                return time;
            },
            headertimeformat(time) {
                var format = "00" + time;
                format = format.substr(format.length - 2);
                return format;
            },
            //遊戲轉點
            updateModal(name,gameHall,gameCode) {
                this.$refs.game.getbalance('Master');
                this.$refs.game.confirmPlayer(name,gameHall,gameCode);
            },
            openModal(Name, Hallid, Gameid) {
                if (isLogin) {
                    //關閉判斷預設開啟轉入
                    // if (WalletType == true){
                        this.useSingleWallet(Name, Hallid, Gameid);
                        return false;
                    // }

                    $("body").addClass("hide");
                    $("#Transfer").show();
                    setTimeout(function() {
                        $(`#Transfer .modal>div`).addClass("active");
                    }, 5)
                    this.updateModal(Name,Hallid, Gameid)
                    this.modalPosition('Transfer')
                } else {
                    annType ? location.href = "./login" : Swal.fire("請先登入", "", "error");
                }
            },
            async useSingleWallet(name, gameHall, gameCode) {
                if (!isLogin) {
                    Swal.fire("請先登入", "", "error");
                    return false;
                }

                let text = this.$refs.game.titleMap[gameHall] || name;

                $(".loading_block").show();

                const res1 = await axios.post("./member_act", Qs.stringify({a: "confirmPlayer", h: gameHall}));
                if (res1.data.success != 0) {
                    $(".loading_block").fadeOut();
                    this.getRequestError(res1, text);
                    return false;
                }

                this.$refs.game.allInGame(gameHall, gameCode);
            },
            getRequestError(res, text = null) {
                switch (res.data.success) {
                    case -99999:
                    case -9999:
                        if (this.logintype) {
                            this.logintype = false;
                            Swal.fire(res.data.msg, '', 'error').then(function () {
                                location.href = './logout';
                                $('.loading_block').show();
                            })
                        }
                    break;
                    default:
                        let msg = res.data.msg || "連線失敗"
                        Swal.fire(msg, text, 'error')
                        break;
                }
            },
            //顯示優惠按鈕
            showBonusButton() {
                $('.bonus-service').hide();
                axios.post("../../member_act.php",Qs.stringify({
                    a: 'showBonusButton',
                    BonusID: this.BonusID,
                }))
                .then(res => {
                    if (res.data.success == 0) {
                        $(".bonus-remark").text("").hide();
                        $('.bonus-btn').text("立即申請").show().prop('disabled', false);
                    } else {
                        if (res.data.remark) {
                            let remark = "";
                            for (let text of res.data.remark) {
                                remark += `<span><i class="fas fa-times-circle"></i>${text}</span>`
                            }
                            $(".bonus-remark").html(remark).show();
                        }

                        if (res.data.success == -100) {
                            $('.bonus-service').text(res.data.msg).show()
                        } else {
                            $('.bonus-btn').text(res.data.msg).show().prop('disabled', true);
                        }
                    }
                })
            },
            //取得優惠按鈕
            getBonusButton(BonusID) {
                $('.bonus-btn').show().attr('disabled', 'disabled');
                axios.post("../../member_act.php",Qs.stringify({
                    a: 'getBonusButton',
                    BonusID:  BonusID,
                }))
                .then(res => {
                     if (res.data.success == 0) {
                        alertSuccess(res.data.msg)
                    } else {
                        switch (res.data.success) {
                            case -99999:
                            case -9999:
                                if (this.logintype) {
                                    this.logintype = false;
                                    Swal.fire(res.data.msg, '', 'error').then(function () {
                                        location.href = './logout';
                                        $('.loading_block').show();
                                    })
                                }
                                break;
                            default:
                                alertError(res.data.msg)
                                break;
                        }
                    }
                })
                .catch(err => {
                })
            },
        },
    });


    //錯誤代碼
    function showErrorCode(name) {
        $('.loading_block').fadeOut();
        Swal.fire(errorCode[name].Name, `代碼 : ${errorCode[name].Code}`, 'error')
    }

    //表單狀態
    function alertSuccess(val) {
        Swal.fire(val, '', 'success')
    }
    function alertError(val, name) {
        $(`input[name=${name}]`).focus();
        $(`select[name=${name}]`).focus();
        Swal.fire(val, '', 'error')
    }
    
    $(document).ready(function(){
        AOS.init();
        //loading
        $('.loading_default>.loading_block').delay(400).fadeOut(1000);

        //刷新驗證碼
        $('.captcha').click(function () {
            var version = Math.random();
            $(".captcha").attr("src", `/captcha?_=${version}`);
        });

        //header active
        let pathsName = $("#pathName").val()
        $(`.nav-${pathsName} > a`).addClass("active")
        $(`.nav-${pathsName} > a > div`).removeClass('ico27').addClass("ico26")
        $(`.nav-${pathsName} > a > div`)
            .removeClass('ico28')
            .addClass('ico29')
            .addClass(`ico29${pathsName}`)

        //現在時間
        setInterval(getDate_ta, 1000);
        function getDate_ta() {
            let today = new Date();
            let date = today.getFullYear() + "-" + twoDigits_ta(today.getMonth() + 1) + "-" + twoDigits_ta(today.getDate()) + " ";
            // var week = " 星期" + "日一二三四五六 ".charAt(today.getDay());
            let time = twoDigits_ta(today.getHours()) + ": " + twoDigits_ta(today.getMinutes()) + ": " + twoDigits_ta(today.getSeconds());
            $("#GET_time").html("GMT+8" + " " + date + " " + time);
        }
        function twoDigits_ta(val) {
            if (val < 10) return "0" + val;
            return val;
        }

        //未登入提醒
        $('.noLogin').click(function () {
            Swal.fire("請先登入", "", "error");
        });
        $('.noApp').click(function () {
            Swal.fire('即將上線', '', 'info')
        });
        //合營提醒
        $('.noJoint').click(function () {
            Swal.fire('敬請期待', '', 'info')
        });

        //公告
        if (annType) {
            // $('.modalBox .new-item:first-child .top').addClass('active')
            // $('.modalBox .new-item:first-child .bottom').show()
            $('.modalBox .new-item').each(function () {
                $(this).find('.top').click(function () {
                    $(this).toggleClass('active')
                    $(this).next().slideToggle();
                });
            });
        } else {
            $('.modalBox .left .new-item:first-child').addClass('active')
            $('.modalBox .right .new-item:first-child').show()
            $('.modalBox .left .new-item').each(function () {
                $(this).click(function () {
                    let bulletinNav = $(this).data('nav')
                    $('.modalBox .left .new-item').removeClass('active')
                    $(this).addClass('active')
                    $('.modalBox .right .new-item').hide()
                    $(`#${bulletinNav}`).show()
                });
            });
        }
        $('#notShowModal').click(function () {
            $(`#News .modal>div`).removeClass("active");
            setTimeout(function() {
                $('body').removeClass('hide');
                $('#News').hide();
                sessionStorage.setItem("RFK3Ann", true);
            }, 300)
        });

        $(".inputChinese").focus(function() {
            let inputName = $(this).attr("name");
            $(`.isChinese[data-input = ${inputName}]`).show();
        })
        $(".inputChinese").focusout(function() {
            let inputName = $(this).attr("name");
            $(`.isChinese[data-input = ${inputName}]`).hide();
        })
    })

    //複製BankAcc
    function copyAcc() {
        let copyText = document.getElementById("bankaccCopy");
        copyText.select();
        copyText.setSelectionRange(0, 99999)
        document.execCommand("copy");
        $("#copySucc").show();
    }

    $('#checkinModal').on('click', function(){
        $(".q-btn").prop("disabled", true).addClass("disabled");
        $(".q-btn").removeClass('active');
        $("#depositAmount").html('載入中');
        $("#betAmount").html('載入中');
        $(".q-btn__content").text('載入中');
        for (i = 0; i < 7; i++) {
            $(`.signProgress_container li:nth-child(${i+1})`).removeClass('sign');
        }
        axios.post("../../checkin_act.php",Qs.stringify({
            a: 'checkinStatus',
        }))
        .then(res => {
            if (res.data.success == 0) {
            let data = res.data.data;
            content = `
            <p style="text-align: left;">每日簽到送彩金</p>
            <li>
                連續簽到七天，只要未簽到，隔天重新算起
            </li>
            <li>
                需儲值3000,有效流水6000 簽到可領取50
            </li>
            <li>
                七天簽滿 額外領取188
            </li>
            <p style="text-align: left;">【注意事項/條款】</p>
            <li style="list-style-type: none;">
                1-任何館別的有效流水都列入計算
            </li>
            <li style="list-style-type: none;">
                2-彩金綁碼1倍
            </li>
            `;

            $("#depositAmount").html(data.userDepositAmount);
            $("#betAmount").html(data.userBetAmount);
            $(".q-btn__content").text(data.statusMessage);
            $(".decmimal").html(content);
            for (i = 0; i < data.CheckinTimes.checkedTimes; i++) {
                $(`.signProgress_container li:nth-child(${i+1})`).addClass('sign');
            }
            if (data.status == 1 || data.status == 2) {
                console.log(data);
                $("button").data("method", data.status);
                $(".q-btn").addClass('active');
                $(".q-btn").prop('disabled', false).removeClass("disabled");
            }
            } else {
            switch (res.data.success) {
                case -99999:
                case -9999:
                if (this.logintype) {
                    this.logintype = false;
                    Swal.fire(res.data.msg, '', 'error').then(function () {
                    location.href = './logout';
                    $('.loading_block').show();
                    })
                }
                break;
                default:
                alertError(res.data.msg)
                break;
            }
            }
        })
        .catch(err => {
        })
    });
    $('.q-btn').on('click', function() {
        $(".q-btn").prop("disabled", true).addClass("disabled");
        $(".q-btn").removeClass('active');
        $("#depositAmount").html('載入中');
        $("#betAmount").html('載入中');
        $(".q-btn__content").text('載入中');
        method = $("button").data("method");
        if (method == 1) method = 'CheckIn';
        if (method == 2) method = 'getBonus';
        axios.post("../../checkin_act.php",Qs.stringify({
            a: method,
        }))
        .then(res => {
            if (res.data.success == 0) {
            Swal.fire(res.data.msg, "", 'success');
            $("#checkinModal").click();
            } else {
            switch (res.data.success) {
                case -99999:
                case -9999:
                if (this.logintype) {
                    this.logintype = false;
                    Swal.fire(res.data.msg, '', 'error').then(function () {
                    location.href = './logout';
                    $('.loading_block').show();
                    })
                }
                break;
                default:
                alertError(res.data.msg)
                $("#checkinModal").click();
                break;
            }
            }
        })
        .catch(err => {
        })
    });

    function getBonus(event, BonusID, DownlineUserID = null) {
        $(event).prop('disabled', true);
        $.ajax({
            url: '/member_act',
            type: 'POST',
            data: {
                a: 'getBonusButton',
                BonusID:  BonusID,
                DownlineUserID: DownlineUserID,
                ShowType: "ShowReferral"
            },
            dataType: 'json'
        }).fail(function(res){
            $(event).prop('disabled', false);
            Swal.fire("出現問題，請稍後再試!", "", "error");
        }).done(function(res) {
            $(event).prop('disabled', false);
            if (res.success == 0) {
                Swal.fire(res.msg, "", 'success');
            } else {
                let remark = "";
                if (res.remark) {
                    for (let text of res.remark) {
                        remark += `<span><i class="fas fa-times-circle" style="margin-right: 5px;"></i>${text}</span>`
                    }
                }
                Swal.fire(res.msg, remark, 'error');
            }
            DownlineUserID > 0 && getSharedbonus();
        })
    }

    dummyPeople() //當前在線人數

    function dummyPeople() {
        let rangData = {
            "second": 40
        };
        let elementD = $('.onlineUser span')
        let elementM = $('.onlineUser1 span')

        let randomNumber = getRandomNumber();

        elementD.text(randomNumber)
        elementM.text(randomNumber)

        getCount(elementD, elementM, rangData);
    }

    function getRandom(min,max){
        return Math.floor(Math.random()*(max-min+1))+min;
    };

    function getRandomNumber(){
        let currentHour = new Date().getHours();
        let onlineRange;

        if (currentHour >= 17 || currentHour < 1) { // 17:00 - 01:00
            onlineRange = {
                "min": 1195,
                "max": 1780
            };
        } else if (currentHour >= 1 && currentHour < 7) { // 01:01 - 07:00
            onlineRange = {
                "min": 658,
                "max": 1050
            };
        } else if (currentHour >= 7 && currentHour < 17) { // 07:01 - 16:59
            onlineRange = {
                "min": 702,
                "max": 950
            };
        }
        return Number(getRandom(onlineRange.min, onlineRange.max)).toLocaleString();
    };
    
    function getCount(elementD, elementM, rangData) {
        setInterval(function timer() {
            let start = parseInt(elementD.text().replace(/,/g, ""))
            let randomNumber = getRandomNumber();
            let end =  parseInt(randomNumber.replace(/,/g, ""))

            $({ count: start }).animate({ count: end }, { //  $( 起始數字 ).animate( 結束數字 )
                duration: 1000, //  動畫執行秒數(ms)
                easing: 'swing', //  動畫切換效果
                step: function(now) { //  動畫執行方式
                    let decimalplace = (Math.round(now));
                    let numberChange = decimalplace.toString().replace(/(\d)(?=(\d{14})+(?!\d))/g, "$1")
                    elementD.text(Number(numberChange).toLocaleString());
                    elementM.text(Number(numberChange).toLocaleString());
                },
                complete: function() { // 動畫完成後
                    countingFromZero = false;
                }
            });
        }, rangData.second * 1000);
    }
}